import jq from 'jquery';
import { cookieBase, cdnUrls, sslBaseUrl } from 'server-data/flconfigs';
import { oneLine } from 'common-tags';
import _ from 'underscore';
import 'bootstrap';
import 'css/flux/modules/Modal.less';
import Modernizr from 'modernizr';
import 'jquery-fileupload';
import 'jquery-fileupload-fp';
import 'jquery-fileupload-ui';
import 'jquery-validate';
import 'mailcheck';
import 'css/flux/legacy/quickhire-modal.less';
import 'css/flux/layout/milestone-modal.less';
import 'css/flux/modules/ModalPaymentVerification.less';
import { authorUserData, isNewUser, portfolioData } from 'server-data/portfolio';

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function getUserIdfromCookie() {
  return getCookie(cookieBase + '_USER_ID');
}

// DEPRECATED. Just use cookieBase from 'server-data/flconfigs'
// const getCookieBase;

function getAuthHeader() {
  var authHashV2 = getCookie(cookieBase + '_AUTH_HASH_V2');
  var userId = getUserIdfromCookie();
  return { 'Freelancer-Auth-V2': userId + ';' + authHashV2 };
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

// Compute the CRC32 of a string
var table = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

/* Number */
function crc32( /* String */str, /* Number */crc) {
  if (crc == undefined) crc = 0;
  var n = 0; // a number between 0 and 255
  var x = 0; // an hex number

  crc ^= -1;
  for (var i = 0, iTop = str.length; i < iTop; i++) {
    n = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(n * 9, 8);
    crc = crc >>> 8 ^ x;
  }
  return crc ^ -1;
}

function cdn_url(url, protocol) {
  // forcing https this way for backwards compat
  protocol = 'https://';

  var host = cdnUrls[Math.abs(crc32(url)) % cdnUrls.length];
  return protocol + host + url;
}

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

var paymentsSourceTemplate = "<div class=\"payment-from\">\n    <div class=\"need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('Utaelekezwa kwenye ukurasa wa kuweka ili kufanya malipo.') %>\n    </div>\n    <div class=\"may-need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('Hii itatolewa kutoka kwa salio lililopo kwenye akaunti yako, kisha ikihitajika, utaelekezwa kwenye ukurasa wa kuweka ili kufanya malipo:') %>\n    </div>\n    <div class='form-only-balance only-balance payment-from-option' style=\"display:none\">\n        <%- T_('Hii itatolewa kutoka kwa salio lililopo kwenye akaunti yako, kisha ikihitajika, utaelekezwa kwenye ukurasa wa kuweka ili kufanya malipo:') %>\n    </div>\n    <%  if (templateData.firstAvailablePaymentMethod) {  %>\n        <div class=\"only-vpm payment-from-option\" style=\"display:none\">\n            <%  if (templateData.verifiedPaymentSourceCount == 1) {  %>\n                <%- T_('Hii itatolewa kutoka kwa mbinu yako ya malipo iliyodhibitishwa.') %>\n            <%  } else {  %>\n                <%- T_('Hii itatolewa kutoka kwa mbinu zako za malipo zilizodhibitishwa.') %>\n            <%  }  %>\n            <%  if (templateData.showWireTransferLink) {  %>\n                <%= T_('Ikiwa ungependa kulipa moja kwa moja kwa benki, tafadhali bonyeza <a class=\"handover-wire-transfer-link\">hapa</a>') %>\n            <%  }  %>\n        </div>\n        <div class=\"mixed-balance-vpm payment-from-option\" style=\"display:none\">\n            <%  if (templateData.verifiedPaymentSourceCount == 1) {  %>\n                <%- T_('Hii itatolewa kutoka kwa salio lililopo kwenye akaunti yako, kisha ikihitajika tutajaribu kukamilisha malipo kutoka kwenye mbinu yako ya malipo iliyodhibitishwa:') %>\n            <%  } else {  %>\n                <%- T_('Hii itatolewa kutoka kwa salio lililopo kwenye akaunti yako, kisha ikihitajika tutajaribu kukamilisha malipo kutoka kwenye mbinu yako ya malipo iliyodhibitishwa:') %>\n            <%  }  %>\n        </div>\n    <%  }  %>\n    <p class=\"form-account-balance account-balances\" style=\"display:none\">\n        <strong><%- T_('Salio la Akaunti:') %></strong>\n        <%  if (templateData.balances) {  %>\n            <%  for (var i = 0; i < templateData.balances.length; i++) {  %>\n                <%-  templateData.balances[i].currency.sign  %><%-  templateData.balances[i].balance.toFixed(2)  %> <%-  templateData.balances[i].currency.code  %><%-  (i == templateData.balances.length - 1) ? '' : ','  %>\n            <%  }  %>\n        <%  }  %>\n    </p>\n</div>\n<%  if (templateData.firstAvailablePaymentMethod) {  %>\n    <div class=\"payment-logos-container\" style=\"display:none\">\n        <h6>\n            <%- T_('Mbinu ya malipo iliyodhibitishwa:') %>\n        </h6>\n\n        <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img-change-preferred-method margin-r20\" style=\"display:none\" />\n        <div class=\"payment-logo-container paypal gatewayPP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayPP') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-paypal\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container cc gatewayGC gatewayWP gatewayNAB gatewayAdyen\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayGC' && templateData.firstAvailablePaymentMethod != 'gatewayWP' && templateData.firstAvailablePaymentMethod != 'gatewayNAB' && templateData.firstAvailablePaymentMethod != 'gatewayAdyen') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-mastercard\"></span>\n            <span class=\"payment-icon-amex\"></span>\n            <span class=\"payment-icon-visa\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container skrill gatewayMB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayMB') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-skrill\"></span>\n        </div>\n        <div class=\"PaymentMethodSettings\">\n            <span class=\"showing-method-account-details gatewayPP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayPP') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.ppEmail) {  %>\n                    <%-  templateData.paymentMethods.ppEmail  %>\n                <%  } %>\n            </span>\n            <span class=\"showing-method-account-details gatewayWP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayWP') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.wpRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.wpRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayWP margin-l20\"><%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.wpRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayNAB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayNAB') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.nabRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.nabRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayNAB margin-l20\"><%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.nabRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayAdyen\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayAdyen') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.adyenRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.adyenRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayAdyen margin-l20\"><%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.adyenRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <div class=\"payment-method-selector\">\n                <%  if (templateData.verifiedPaymentSourceCount > 1) {  %>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control open-change-preferred-method\">\n                        <%- T_('Hariri unayoyapendelea') %>\n                    </a>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control close-change-preferred-method\" style=\"display:none\">\n                        <%- T_('Batilisha') %>\n                    </a>\n                    <span class=\"PaymentMethodSettings-control PaymentMethodSettings-control-separator\" <%  if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) {  %> style=\"display:none\" <%  }  %>> | </span>\n                <%  }  %>\n                <span class=\"PaymentMethodSettings-control is-PaymentMethodSettings-control-active\" <%  if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) {  %> style=\"display:none\" <%  }  %>><%- T_('Anayependelewa') %></span>\n            </div>\n            <span class=\"showing-method-account-details gatewayGC\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayGC') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.gcRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.gcRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayGC margin-l20\"><%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.gcRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayMB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayMB') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.skrillPaymentVerified.length == 1) {  %>\n                    <%- T_('Kitambulisho cha Itisho') %> <%-  templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id  %>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayMB\"><%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length }) %></span>\n                <%  }  %>\n            </span>\n            <div class=\"clear\"></div>\n            <select class=\"default-select change-preferred-method\" style=\"display:none\">\n                <option value=\"\" selected=\"selected\"><%- T_('Chagua mbinu yako ya malipo unayoipendelea') %></option>\n                <%  if (templateData.paymentMethods.ppEmail) {  %>\n                    <option value=\"gatewayPP\"><%-  T_('Paypal:')  %> (<%-  templateData.paymentMethods.ppEmail  %>)</option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.gcRecurring) {  %>\n                    <option value=\"gatewayGC\"><%-  T_('Credit Card:')  %>\n                        <%  if (templateData.paymentMethods.gcRecurring.length == 1) {  %>\n                            (<%-  templateData.paymentMethods.gcRecurring[0]['cc_number']  %>)\n                        <%  } else {  %>\n                            (<%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.gcRecurring.length }) %>)\n                        <%  }  %>\n                    </option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.wpRecurring) {  %>\n                    <option value=\"gatewayWP\"><%-  T_('Credit Card:')  %>\n                    <%  if (templateData.paymentMethods.wpRecurring.length == 1) {  %>\n                        (<%-  templateData.paymentMethods.wpRecurring[0]['cc_number']  %>)\n                    <%  } else {  %>\n                        (<%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.wpRecurring.length }) %>)\n                    <%  }  %>\n                    </option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.skrillPaymentVerified) {  %>\n                    <option value=\"gatewayMB\"><%-  T_('Skrill:')  %>\n                    <%  if (templateData.paymentMethods.skrillPaymentVerified.length == 1) {  %>\n                        (<%- T_('Kitambulisho cha Itisho:') %> <%-  templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id  %>)\n                    <%  } else {  %>\n                        (<%= T_('Akaunti <[-numberOfAccounts]> zipo', { 'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length }) %>)\n                    <%  }  %>\n                    </option>\n                <%  }  %>\n            </select>\n        </div>\n        <div class=\"payments-source-generic-error margin-t10 alert alert-error\" style=\"display:none\"></div>\n    </div>\n<%  }  %>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-payments-source.js
 * Please replicate all changes to the other file.
 */

var moduleData = false;
var $el = false;
var moduleSettings = {
  disableCC: false,
  disableBalance: false,
  showWireTransferLink: false };

function init(paymentsSourceDetails, paymentsSourceContainer, preferredSettings) {
  jq.extend(moduleSettings, preferredSettings);

  if (typeof paymentsSourceDetails === 'object') {
    moduleData = paymentsSourceDetails;
  } else {
    return;
  }
  if (typeof paymentsSourceContainer !== 'undefined') {
    $el = paymentsSourceContainer;
  } else {
    return;
  }
  if (!validateAndPrepareData()) {
    return;
  }
  $el.html('<img src="' + cdn_url('/img/ajax-loader.gif') + '" ' + 'class="loading-payment-source-module margin-center block" />');

  jq.ajax({
    type: 'post',
    data: {
      currency: moduleData.currencyDetails.id },

    url: '/ajax/payment/getUserPaymentMethodInfo.php',
    dataType: 'json',
    success: function success(response) {
      if (response.status == 'success') {
        moduleData.balances = response.balances;
        moduleData.paymentMethods = response.paymentMethods;
        moduleData.firstAvailablePaymentMethod = response.firstAvailablePaymentMethod;
        moduleData.preferredPaymentMethod = response.preferredPaymentMethod;
        for (var i = 0; i < moduleData.balances.length; i++) {
          if (parseFloat(moduleData.balances[i].balance) > 0) {
            moduleData.totalBalanceIsEmpty = false;
            break;
          }
        }

        if (moduleSettings.disableCC) {
          removeCC();
        }

        if (moduleSettings.disableBalance) {
          removeBalance();
        }

        if (moduleSettings.showWireTransferLink) {
          includeWireTransferLink();
        }

        reconstructBalances();
        countVerifiedPaymentSource();
        render();
        buildBinds();
        checkPaymentSource(moduleData.amount);
      }
    },
    complete: function complete() {
      $el.find('.loading-payment-source-module').remove();
    }
  });
}

function removeCC() {
  moduleData.hasVerifiedCreditCard = moduleData.paymentMethods.gcRecurring || moduleData.paymentMethods.wpRecurring;
  moduleData.removedCC = true;
  moduleData.paymentMethods.gcRecurring = false;
  moduleData.paymentMethods.wpRecurring = false;

  moduleData.preferredPaymentMethod = 'gatewayPP';
  moduleData.firstAvailablePaymentMethod = 'gatewayPP';
}

function removeBalance() {
  moduleData.balances = [];
  moduleData.totalBalanceIsEmpty = true;
}

function includeWireTransferLink() {
  moduleData.showWireTransferLink = true;
}

function validateAndPrepareData() {
  if (typeof moduleData.amount === 'undefined' || Number.isNaN(moduleData.amount) || !moduleData.amount || typeof moduleData.currencyDetails === 'undefined') {
    return false;
  }
  moduleData.amount = parseFloat(moduleData.amount);
  moduleData.primaryBalanceForPayment = false;
  moduleData.totalBalanceIsEmpty = true;
  moduleData.verifiedPaymentSourceCount = 0;
  return true;
}

function render() {
  var tpl = paymentsSourceTemplate;

  if (typeof tpl === 'undefined') {
    tpl = jq('#payment-source-template').html();
  }

  $el.html(_.template(tpl)({
    templateData: moduleData,
    T_: translate,
    cdn_url: cdn_url }));
}

function checkPaymentSource(amountToCheck) {
  $el.find('.payment-from-option, .account-balances, .payment-logos-container').hide();
  if (Number.isNaN(amountToCheck) || !amountToCheck) {
    return;
  }

  amountToCheck = parseFloat(amountToCheck);

  if (moduleData.totalBalanceIsEmpty) {
    // If all balances are zero
    if (moduleData.firstAvailablePaymentMethod) {
      $el.find('.only-vpm, .payment-logos-container').show();
    } else {
      customizePaymentSourceNeedDepositContent();
      $el.find('.need-deposit').show();
    }
  } else if (moduleData.primaryBalanceForPayment && amountToCheck <= moduleData.primaryBalanceForPayment.balance) {
    // If primary balance is sufficient
    $el.find('.only-balance, .account-balances').show();
    // Primary balance is insufficient but not zero balances among all balances
  } else if (moduleData.firstAvailablePaymentMethod) {
    $el.find('.mixed-balance-vpm, .account-balances, .payment-logos-container').show();
  } else if (moduleData.balances.length === 1 && moduleData.balances[0].currency.id == moduleData.currencyDetails.id) {
    customizePaymentSourceNeedDepositContent();
    $el.find('.need-deposit').show();
  } else {
    $el.find('.may-need-deposit, .account-balances').show();
  }
}

function buildBinds() {
  jq(document).ready(function () {
    $el.off('change', '.change-preferred-method').on('change', '.change-preferred-method', function () {
      var that = jq(this);
      var method = that.val();
      if (!method) {
        return;
      }
      var existingMethod = $el.find('.payment-logo-container:visible, ' + '.showing-method-account-details:visible');

      jq.ajax({
        url: '/ajax/user/setUserPreferedPayment.php',
        dataType: 'json',
        type: 'post',
        data: {
          method: method },

        beforeSend: function beforeSend() {
          that.hide();
          $el.find('.payment-logo-container, .close-change-preferred-method, ' + '.showing-method-account-details').hide();
          $el.find('.loading-img-change-preferred-method, ' + '.open-change-preferred-method').show();
          $el.find('.payments-source-generic-error').html('').hide();
          $el.closest('.modal').find('.btn').attr('disabled', true);
        },
        success: function success(response) {
          if (response.result == 'success') {
            $el.find('.is-preferred, .is-preferred-separator, ' + ('.payment-logo-container.' + method + ', ') + ('.showing-method-account-details.' + method)).show();
            moduleData.preferredPaymentMethod = method;
          } else {
            $el.find('.payments-source-generic-error').html(translate('Imeshindwa kuhifadhi mbinu yako ya malipo unayoipendelea. Jaribu tena.')).show();
            existingMethod.show();
          }
        },
        error: function error() {
          $el.find('.payments-source-generic-error').html(translate('Kasoro ya Mtandao')).show();
          existingMethod.show();
        },
        complete: function complete() {
          $el.find('.loading-img-change-preferred-method').hide();
          // front end delay for potential slave drift
          setTimeout(function () {
            $el.closest('.modal').find('.btn').removeAttr('disabled');
          }, 1200);
        }
      });
    });

    $el.off('click', '.open-change-preferred-method').on('click', '.open-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.is-preferred').hide();
      $el.find('.change-preferred-method, .close-change-preferred-method').show();
    });

    $el.off('click', '.close-change-preferred-method').on('click', '.close-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.change-preferred-method').hide();
      if (moduleData.preferredPaymentMethod) {
        $el.find('.is-preferred').show();
      }
      $el.find('.open-change-preferred-method').show();
    });

    $el.find('.payment-source-tooltip.gatewayGC').popover({
      content: function content() {
        var gatewayGCAccounts = [];
        if (moduleData.paymentMethods.gcRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.gcRecurring.length; i++) {
            gatewayGCAccounts.push(moduleData.paymentMethods.gcRecurring[i].cc_number);
          }
        }
        return gatewayGCAccounts.join('<br>');
      },

      title: 'Credit cards',
      placement: 'top',
      html: true,
      trigger: 'hover' });

    $el.find('.payment-source-tooltip.gatewayWP').popover({
      content: function content() {
        var gatewayWPAccounts = [];
        if (moduleData.paymentMethods.wpRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.wpRecurring.length; i++) {
            gatewayWPAccounts.push(moduleData.paymentMethods.wpRecurring[i].cc_number);
          }
        }
        return gatewayWPAccounts.join('<br>');
      },

      title: translate('Kadi za Malipo'),
      placement: 'top',
      html: true,
      trigger: 'hover' });

    $el.find('.payment-source-tooltip.gatewayMB').popover({
      content: function content() {
        var gatewayMBAccounts = [];
        if (moduleData.paymentMethods.skrillPaymentVerified) {
          for (var i = 0; i < moduleData.paymentMethods.skrillPaymentVerified.length; i++) {
            gatewayMBAccounts.push(moduleData.paymentMethods.skrillPaymentVerified[i].onetap_invoice_id);
          }
        }
        return gatewayMBAccounts.join('<br>');
      },

      placement: 'top',
      html: true,
      trigger: 'hover' });
  });
}

function reconstructBalances() {
  // Remove balances with zero amount and set the primary balance to balance
  // with payment's currency
  for (var i = 0; i < moduleData.balances.length;) {
    moduleData.balances[i].balance = parseFloat(moduleData.balances[i].balance);
    if (moduleData.balances[i].balance == 0) {
      moduleData.balances.splice(i, 1);
    } else if (moduleData.balances[i].currency.id == moduleData.currencyDetails.id) {
      moduleData.primaryBalanceForPayment = moduleData.balances[i];
      moduleData.balances.splice(i, 1);
    } else {
      i++;
    }
  }
  if (moduleData.primaryBalanceForPayment) {
    moduleData.balances.unshift(moduleData.primaryBalanceForPayment);
  }
}

function countVerifiedPaymentSource() {
  if (moduleData.firstAvailablePaymentMethod) {
    if (moduleData.paymentMethods.ppEmail) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.gcRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.wpRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.skrillPaymentVerified) {
      moduleData.verifiedPaymentSourceCount++;
    }
  }
}

function customizePaymentSourceNeedDepositContent() {
  if (typeof moduleData.needDepositCustomTitle !== 'undefined') {
    $el.closest('.modal').find('.modal-header h3').html(moduleData.needDepositCustomTitle);
  }

  if (typeof moduleData.needDepositCustomBody !== 'undefined') {
    $el.find('.need-deposit').html(moduleData.needDepositCustomBody);
  }
  if (typeof moduleData.needDepositAmountDiv !== 'undefined' && !moduleData.needDepositAmountDiv) {
    $el.find('.payment-from').hide();
    $el.closest('.modal-body').find('p:first').hide();
  }

  if (typeof moduleData.needDepositConfirmText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-confirm-payment').html(moduleData.needDepositConfirmText);
  }
  if (typeof moduleData.needDepositCancelText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-cancel-payment').html(moduleData.needDepositCancelText);
  }
}

var paymentSource = {
  init: init,
  checkPaymentSource: checkPaymentSource };

var awardUpgradeTemplate = "<thead>\n  <tr>\n      <th class=\"milestone-table-name\" colspan=\"4\"><%- T_('Viboresho Vinavyopendekezwa') %></th>\n  </tr>\n</thead>\n<tbody class=\"project-displayed-upgrades\">\n    <%  if (!templateVars.upgraded.nda) {  %>\n    <tr class=\"upgrade-listing-upgrade js-upgrade\">\n        <td class=\"upgrade-listing-select\">\n            <input type=\"checkbox\" name=\"chkbx_nda\" data-name=\"nda\"\n                   class=\"custom-checkbox upgrade-checkbox\" id=\"checkbox_nda\"\n                   <%  if (templateVars.hireMeNdaPreTick) {  %> checked <%  } %>>\n            <label class=\"custom-checkbox\" for=\"checkbox_nda\"></label>\n        </td>\n        <td class=\"upgrade-listing-type\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_nda\">\n            <span class=\"promotion-tag has-no-icon promotion-nda\"><%-  T_('NDA') %></span>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-description\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_nda\">\n            <%= T_('Wafanyakazi huru ni sharti watie sahihi <a href=\"/NDA/NDA-print-contract.php\" target=\"_blank\">Makubaliano ya Kutotoa Taarifa</a> ili kufanya kazi kwa mradi wako.') %>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-price js-upgrade-price\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_nda\">\n            <%  if (templateVars.upgrade_prices.nda == 0) { %>\n            <span><%- T_('BURE') %></span>\n            <%  } else {  %>\n            <span class=\"currency-sign\"><%-  templateVars.currency  %></span><span class='upgrade-price' id=\"nda-upgrade-price\"><%-  (templateVars.upgrade_prices.nda).toFixed(2)  %></span>\n            <%  }  %>\n            </label>\n        </td>\n    </tr>\n    <%  }  %>\n</tbody>\n<tbody class=\"is-hidden project-hidden-upgrades\">\n    <%  if (!templateVars.upgraded.nonpublic) {  %>\n    <tr class=\"upgrade-listing-upgrade js-upgrade project-upgrade-item\">\n        <td class=\"upgrade-listing-select\">\n            <input type=\"checkbox\" name=\"chkbx_nonpublic\" data-name=\"private\" class=\"custom-checkbox upgrade-checkbox\" id=\"checkbox_private\">\n            <label class=\"custom-checkbox\" for=\"checkbox_private\"></label>\n        </td>\n        <td class=\"upgrade-listing-type\">\n          <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_private\">\n            <span class=\"promotion-tag has-no-icon promotion-private\"><%- T_('Ya Kibinafsi') %></span>\n          </label>\n        </td>\n        <td class=\"upgrade-listing-description\">\n          <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_private\">\n            <%= T_('Nataka ku <strong>ficha maelezo ya mradi</strong> kutoka kwa mitandao ya kutafuta na watumiaji ambao hawajaingia.') %>\n            <%- T_('Mfumo huu unapendekezwa kwa miradi ambayo usiri ni lazima.') %>\n          </label>\n        </td>\n        <td class=\"upgrade-listing-price js-upgrade-price\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_private\">\n            <%  if (templateVars.upgrade_prices.nonpublic == 0) { %>\n            <span><%- T_('BURE') %></span>\n            <%  } else {  %>\n            <span class=\"currency-sign\"><%-  templateVars.currency  %></span><span class='upgrade-price' id=\"private-upgrade-price\"><%-  (templateVars.upgrade_prices.nonpublic).toFixed(2)  %></span>\n            <%  }  %>\n            </label>\n        </td>\n    </tr>\n    <%  }  %>\n    <%  if (!templateVars.upgraded.fulltime) {  %>\n    <tr class=\"upgrade-listing-upgrade js-upgrade project-upgrade-item\" style=\"display: table-row;\">\n        <td class=\"upgrade-listing-select\">\n            <input type=\"checkbox\" name=\"chkbx_fulltime\" data-name=\"fulltime\" class=\"custom-checkbox upgrade-checkbox\" id=\"checkbox_fulltime\">\n            <label class=\"custom-checkbox\" for=\"checkbox_fulltime\"></label>\n        </td>\n        <td class=\"upgrade-listing-type\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_fulltime\">\n            <span class=\"promotion-tag has-no-icon promotion-fulltime\"><%- T_('Wakati Wote') %></span>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-description\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_fulltime\">\n            <%- T_('Mradi huu ni wa kuajiri nafasi ya wakati wote ama ya kiujira (k.v. Mauzo) na utaokoa pesa ikiwa una kazi inayoendelea. Ada zinatozwa tu ikiwa thamani ya mradi inazidi $5000 USD.') %>\n            </label>\n        </td>\n        <td class=\"upgrade-listing-price js-upgrade-price\">\n            <label class=\"upgrade-listing-select-label custom-checkbox\" for=\"checkbox_fulltime\">\n            <%  if (templateVars.upgrade_prices.fulltime == 0) { %>\n            <span><%- T_('BURE') %></span>\n            <%  } else {  %>\n            <span class=\"currency-sign\"><%-  templateVars.currency  %></span><span class='upgrade-price' id=\"fulltime-upgrade-price\"><%-  (templateVars.upgrade_prices.fulltime).toFixed(2)  %></span>\n            <%  }  %>\n            </label>\n        </td>\n    </tr>\n    <%  }  %>\n</tbody>\n";

var $el$1 = void 0;
var createMilestone = void 0;
var milestoneScope = void 0;
var milestoneData = void 0;

var project = void 0;
var upgradePrices = {};
var upgraded = {};
var projectConfig = {};

var showUpgrade = true;
var upgradeData = [];

var abTestPrehire = false;

function init$1() {
  if (!showUpgrade) {
    return;
  }
  if (jq('#milestone-modal-upgrade-section').is(':empty')) {
    render$1();
  }
  // Add QTS events for different upgrades.
  jq('input[type="checkbox"]').change(function () {
    var qtsData = {
      section: 'ProjectUpgrade',
      subsection: 'HireMe Milestone',
      label: this.checked ? 'select' : 'unselect',
      action: this.checked ? 'click' : 'unclick',
      name: 'Upgrade Type',
      value: jq(this).data('name') };

    if (typeof project !== 'undefined') {
      qtsData.reference = 'project_id';
      qtsData.reference_id = project.id;
    }
    window._t.push(['user_action', qtsData]);
  });
}

function render$1() {
  jq('#milestone-modal-upgrade-section').append(_.template(awardUpgradeTemplate)({
    templateVars: prepareVars(),
    T_: translate })).removeClass('is-hidden');
  $el$1 = jq('#milestone-modal-upgrade-section');
  buildBind();
}

// determine whether to show upgrades upsell section
function prepareUpgradeABTest(id, master) {
  var deferred = jq.Deferred();
  var data = {
    id: id };

  if (master) {
    data.m = 1;
  }
  jq.ajax({
    type: 'get',
    url: '/ajax/buyer/upgrade_info.php',
    data: data,
    dataType: 'json',
    success: function success(response) {
      if (response.status === 'success') {
        // if can not be upgrade then skip upsell upgrade step
        if (!response.can_be_upgraded) {
          showUpgrade = false;
        }
        // if no more upgrades to upsell then skip upsell upgrade step
        upgraded.nda = response.project.NDA !== 'N';
        upgraded.nonpublic = response.project.nonpublic !== '0';
        upgraded.fulltime = response.project.fulltime !== '0' || response.project.hourly !== '0';
        if (upgraded.nda && upgraded.nonpublic && upgraded.fulltime) {
          showUpgrade = false;
        }
        project = response.project;
        projectConfig = response.project_config;
      } else {
        showUpgrade = false;
      }
      deferred.resolve(showUpgrade);
    },
    error: function error() {
      showUpgrade = false;
      deferred.resolve(showUpgrade);
    }
  });

  return deferred.promise();
}

function prepareUpgradeForPreHireChat(currency_id) {
  abTestPrehire = true;
  var deferred = jq.Deferred();
  var data = {
    raw: true,
    currency: currency_id };

  jq.ajax({
    type: 'get',
    url: '/buyers/on-currency-control.php',
    data: data,
    dataType: 'json',
    success: function success(response) {
      if (response.status === 'success') {
        projectConfig = {
          nonpublic_price: parseFloat(response.projectConfig.nonpublic_price),
          NDA_price: parseFloat(response.projectConfig.NDA_price),
          fulltime_price: parseFloat(response.projectConfig.fulltime_price),
          currency: response.currencyArray.sign };
      } else {
        showUpgrade = false;
      }
      deferred.resolve(showUpgrade);
    },
    error: function error() {
      showUpgrade = false;
      deferred.resolve(showUpgrade);
    }
  });

  return deferred.promise();
}

function prepareVars() {
  var vars = {};
  upgradePrices.nonpublic = projectConfig.nonpublic_price;
  upgradePrices.nda = projectConfig.NDA_price;
  upgradePrices.fulltime = projectConfig.fulltime_price;
  vars.upgrade_prices = upgradePrices;
  vars.upgraded = upgraded;
  if (!abTestPrehire) {
    vars.currency = project.currency.sign;
  } else {
    vars.currency = projectConfig.currency;
  }
  return vars;
}

function buildBind() {
  if (jq.trim($el$1.find('.project-displayed-upgrades').html()) === '') {
    var hiddenUpgrades = $el$1.find('.project-hidden-upgrades');
    jq(hiddenUpgrades).find('tr').first().appendTo($el$1.find('.project-displayed-upgrades'));
  }
  if (jq.trim($el$1.find('.project-hidden-upgrades').html()) !== '') {
    var viewMore = translate('Angalia viboresho zaidi');
    var viewMoreHTML = '\n      <a href="#" class="upgrade-listing-more">' + viewMore + '</a>';
    $el$1.find('.upgrade-listing-upgrade .upgrade-listing-description').first().append(viewMoreHTML);
    $el$1.find('.upgrade-listing-more').click(function (e) {
      jq(e.target).remove();
      $el$1.find('.project-hidden-upgrades').removeClass('is-hidden');
    });
  }
}

function doUpgrade(projectId) {
  var deferred = jq.Deferred();
  var ajaxData = {};
  ajaxData.csrf_token = getCSRFToken();
  ajaxData.data = {};
  getUpgrades();
  jq.each(upgradeData, function (i, upgrade) {
    ajaxData.data[upgrade] = 'on';

    window._t.push(['user_action', {
      section: 'ProjectUpgrade',
      subsection: 'HireMe Milestone',
      label: 'confirm payment',
      action: 'click',
      name: 'Upgrade Type',
      value: upgrade,
      reference: 'project_id',
      reference_id: projectId }]);
  });
  ajaxData.id = projectId;
  jq.ajax({
    type: 'post',
    url: '/ajax/buyer/onupgrade.php',
    dataType: 'json',
    data: ajaxData,
    success: function success(resp) {
      if (resp.status === 'failed') {
        deferred.reject(resp.error);
      } else if (resp.status === 'insuffunds') {
        window.location.replace(resp.depositLink);
        deferred.reject('');
      } else {
        deferred.resolve(true);
      }
    },
    error: function error() {
      var errorMessage = translate('Kasoro ya ndani, tafadhali jaribu tena baadaye.');
      deferred.reject(errorMessage);
    }
  });

  return deferred.promise();
}

// // used for upgrade and create milestone on nonhireme award
function upgradeAndCreateMilestoneBreakdowns(data, callback, scope) {
  milestoneData = data;
  createMilestone = callback;
  milestoneScope = scope;
  var $footer = jq('.milestone-modal .modal-footer');
  var spinner = '\n    <img id="award-loading" src="' + cdn_url('/img/ajax-loader.gif') + '"/>';
  jq('#milestone-error').html('');
  if (upgradeData.length > 0) {
    $footer.append(spinner).find('.btn').hide();
    // preprocess
    prepareAmount(upgradeData, milestoneData).then(function () {
      // milestone
      createMilestone.call(milestoneScope, milestoneData);
      // upgrade
      var upgradeCallData = {
        id: project.id,
        data: {} };

      jq.each(upgradeData, function (key, upgrade) {
        upgradeCallData.data[upgrade] = 'on';
      });
      jq('#upgradeProjectContainer').trigger('onupgradeCall', [upgradeCallData]);
    }, function (error) {
      if (error) {
        jq('#milestone-error').html(error);
      }
    }).always(function () {
      $footer.find('#award-loading').remove();
      $footer.find('.btn').show();
    });
  } else {
    createMilestone.call(milestoneScope, milestoneData);
  }
}

// used for upgrade and create milestone on hireme
function upgradeAndCreateMilestone(data, form, callback, scope) {
  var isPrehireProject = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  milestoneData = {};
  milestoneData.milestone_amount = form.find('.milestone-amount').val();
  milestoneData.description = form.find('.milestone-descr').val();
  milestoneData.project_id = data.project_id;
  milestoneData.currency_id = data.currency_id;
  milestoneData.seller_id = data.seller_id;
  milestoneData.seller_name = data.seller_username;

  createMilestone = callback;
  var $footer = jq('.milestone-modal .modal-footer');
  var spinner = '\n    <img id="award-loading" src="' + cdn_url('/img/ajax-loader.gif') + '" />';
  jq('#milestone-error').html('');
  if (upgradeData.length > 0) {
    $footer.append(spinner).find('.btn').hide();
    // preprocess
    prepareAmount(upgradeData, milestoneData).then(function () {
      // upgrade
      doUpgrade(data.project_id).then(function () {
        // milestone
        createMilestone.call(scope, form, isPrehireProject);
      }, function (error) {
        if (error) {
          jq('#milestone-error').html(error);
        }
        $footer.find('.btn').show();
      }).always(function () {
        $footer.find('#award-loading').remove();
      });
    }, function (error) {
      jq('#milestone-error').html(error);
    });
  } else {
    createMilestone.call(scope, form, isPrehireProject);
  }
}

function prepareAmount(upgradeData, milestoneData) {
  var deferred = jq.Deferred();
  var ajaxData = milestoneData;
  ajaxData.chosen_upgrades = upgradeData;
  jq.ajax({
    type: 'post',
    url: '/ajax/payment/on-preprocess-upgrades-and-milestones.php',
    dataType: 'json',
    data: ajaxData,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    success: function success(response) {
      if (response.status === 'success') {
        if (response.force_pv) {
          window.location.href = '/verify?next=/projects/' + milestoneData.project_id + '&data_token=' + response.data_token;
          deferred.reject('');
        } else if (response.diff_amount) {
          var uri = '/deposit/?' + ('amount=' + encodeURIComponent(response.diff_amount)) + ('&currency=' + encodeURIComponent(response.currency_id)) + ('&id=' + encodeURIComponent(response.project_id));
          if (response.ref_action && response.data_token) {
            uri += '&refAction=' + response.ref_action;
            uri += '&dataToken=' + response.data_token;
          }
          if (response.back_url) {
            uri += '&back=' + response.back_url;
          }
          window.location = uri;
          deferred.reject('');
        } else {
          deferred.resolve(true);
        }
      } else {
        deferred.reject(response.msg);
      }
    },
    error: function error() {
      var errorMessage = translate('Kasoro ya ndani, tafadhali jaribu tena baadaye.');
      deferred.reject(errorMessage);
    }
  });

  return deferred.promise();
}

function getUpgrades() {
  upgradeData = [];
  if ($el$1.find('#checkbox_nda').length > 0 && $el$1.find('#checkbox_nda').is(':checked')) {
    upgradeData.push('nda');
  }
  if ($el$1.find('#checkbox_private').length > 0 && $el$1.find('#checkbox_private').is(':checked')) {
    upgradeData.push('nonpublic');
  }
  if ($el$1.find('#checkbox_fulltime').length > 0 && $el$1.find('#checkbox_fulltime').is(':checked')) {
    upgradeData.push('fulltime');
  }
}

function getUpgradeTotal() {
  getUpgrades();
  var total = 0;
  jq.each(upgradeData, function (i, upgrade) {
    total += upgradePrices[upgrade];
  });
  return total;
}

var awardUpgrades = {
  init: init$1,
  prepareUpgradeABTest: prepareUpgradeABTest,
  prepareUpgradeForPreHireChat: prepareUpgradeForPreHireChat,
  upgradeAndCreateMilestoneBreakdowns: upgradeAndCreateMilestoneBreakdowns,
  upgradeAndCreateMilestone: upgradeAndCreateMilestone,
  getUpgradeTotal: getUpgradeTotal };

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var template$1 = "<div id=\"<%=  id  %>\" class=\"Modal <%=  extraClass  %>\" data-modal aria-hidden=\"<%=  hideModal  %>\">\n  <div class=\"Modal-inner\" <%  if (backdropClose) {  %> data-modal-outbound <%  }  %>>\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <%  if (closeButton) {  %>\n        <button class=\"Modal-close\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\">\n          <span class=\"Icon Icon--small\"><%=  uiIcon('ui-close')  %></span>\n        </button>\n        <%  }  %>\n        <%  if (header) {  %>\n        <header class=\"Modal-header\">\n          <%=  header  %>\n        </header>\n        <%  }  %>\n        <%  if (body) {  %>\n        <div class=\"Modal-body\">\n          <%=  body  %>\n        </div>\n        <%  }  %>\n        <%  if (footer) {  %>\n        <footer class=\"Modal-footer\">\n          <%=  footer  %>\n        </footer>\n        <%  }  %>\n      </div>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var OPEN_EVENT = {
  METHOD: 'method'
};

var CLOSE_EVENT = {
  ESC: 'esc',
  OUTOFBOUNDS: 'outofbounds',
  ELEMENT: 'element'
};

var defaultOptions = {
  main: document.querySelector('#main'),
  closeButton: true,
  backdropClose: true,
  extraClass: '',
  size: '',
  type: ''
};

// Template the modal's scaffolding by injecting header, body and footer
var scaffold = template(template$1);

/**
 * Modal constructor
 * @param {Node} node Dialog element
 * @param {Node} main Main element of the page
 */

var Modal = function () {
  /**
   * Modal constructor
   * @param  {String}   id                       An ID to apply to the modal.
   * @param  {Object}   content                  Content object to inject in the
   *                                             modal.
   * @param  {String}   content.header           Content for the header.
   * @param  {String}   content.body             Content for the body.
   * @param  {String}   content.footer           Content for the footer.
   * @param  {Object}   [options={}]             Options object for customise
   *                                             behaviour of modal.
   * @param  {Node}     [options.main]           An element to treat as the main
   *                                             content so that
   *                                             aria-hidden="true" can be
   *                                             toggled. Defaults to #main.
   * @param  {Boolean}  [options.closeButton]    Shows the x close button.
   *                                             Defaults to true.
   * @param  {Boolean}  [options.backdropClose]  Enables closing of modal via
   *                                             clicking on the backdrop.
   *                                             Defaults to true.
   * @param  {String}   [options.extraClass]     Adds extra classes to the
   *                                             modal.
   * @param  {String}   [options.size]           Sets the size of the modal.
   * @param  {String}   [options.type]           Sets the type of the modal.
   * @param  {Function} [options.onShow]         Callback function after showing
   *                                             the modal.
   * @param  {Function} [options.onHide]        Callback function after closing
   *                                             the modal.
   * @return {Modal}                             Modal instance.
   */
  function Modal(id, content, opts) {
    _classCallCheck(this, Modal);

    // Merge user options with defaultOptions
    var options = Object.assign({}, defaultOptions, opts);

    // Build configuration
    this.config = {
      id: id,
      content: {
        header: content.header,
        body: content.body,
        footer: content.footer
      },
      options: options
    };

    // Errors
    if (typeof this.config.id === 'undefined') {
      throw new TypeError('Modal id cannot be undefined.');
    }

    if (typeof this.config.content === 'undefined') {
      throw new TypeError('Modal content cannot be undefined.');
    }

    if (typeof this.config.options.main === 'undefined') {
      throw new TypeError('#main element does not exist.');
    }

    this.namespace = 'data-modal';
    this.body = document.body;
    this.main = this.config.options.main;

    // Appends markup to the body just before the </body>
    this.body.insertAdjacentHTML('beforeend', scaffold({
      uiIcon: uiIcon,
      id: this.config.id,
      hideModal: true,
      header: this.config.content.header,
      body: this.config.content.body,
      footer: this.config.content.footer,
      closeButton: this.config.options.closeButton,
      backdropClose: this.config.options.backdropClose,
      extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
    }));

    this.node = document.getElementById(this.config.id);
    this.shown = false;

    this._bindEventsToModal();
    return this;
  }

  /**
   * Helper function that binds modal events to the modal element
   */

  _createClass(Modal, [{
    key: '_bindEventsToModal',
    value: function _bindEventsToModal() {
      var _this = this;

      // Bind show modal event to elements with <this.namespace>-show="<modal-id>"
      // data attributes
      Array.from(
      // Get all the elements with <this.namespace>-show="<modal-id>"
      document.querySelectorAll('[' + this.namespace + '-show="' + this.node.id + '"]')).forEach(function (opener) {
        opener.addEventListener('click', function () {
          return _this.show();
        });
      });

      // Bind hide modal event to elements with <this.namespace>-hide data
      // attributesmodules/membership/index.js
      Array.from(
      // Get all elements with <this.namespace>-hide inside the modal
      this.node.querySelectorAll('[' + this.namespace + '-hide]'))
      // Then combine it with all elements on the page that targets the modal
      // with <this.namespace>-hide="<modal-id>" for hiding
      .concat(Array.from(document.querySelectorAll('[' + this.namespace + '-hide="' + this.node.id + '"]'))).forEach(function (closer) {
        closer.addEventListener('click', function () {
          return _this.hide(CLOSE_EVENT.ELEMENT);
        });
      });

      // Hides modal when the user clicks out of bounds
      this.node.addEventListener('click', function (event) {
        if (event.target.hasAttribute(_this.namespace + '-outbound')) {
          _this.hide(CLOSE_EVENT.OUTOFBOUNDS);
        }
      });

      document.addEventListener('keydown', function (event) {
        // keydown on Esc key
        if (_this.shown && event.which === 27) {
          event.preventDefault();
          _this.hide(CLOSE_EVENT.ESC);
        }

        // keydown on Tab key
        if (_this.shown && event.which === 9) {
          _this._trapTabKey(_this.node, event);
        }
      });

      this.body.addEventListener('focus', function (event) {
        if (_this.shown && !_this.node.contains(event.target)) {
          _this._setFocusToFirstItem(_this.node);
        }
      }, true);
    }

    /**
     * Helper function to get all focusable children from a node
     * @param  {Node} node Node to look in
     * @return {Array}     Array of focusable nodes
     */

  }, {
    key: '_getFocusableChildren',
    value: function _getFocusableChildren(node) {
      var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

      return Array.from(node.querySelectorAll(focusableElements.join(','))).filter(function (child) {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
      });
    }

    /**
     * Helper function trapping the tab key inside a node
     * @param  {Node} node    Node to trap tab key in
     * @param  {Object} event Event to intercept
     */

  }, {
    key: '_trapTabKey',
    value: function _trapTabKey(node, event) {
      var focusableChildren = this._getFocusableChildren(node);
      var focusedItemIndex = focusableChildren.indexOf(document.activeElement);

      if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
      } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
      }
    }

    /**
     * Helper function to focus first focusable item in node
     * @param {Node} node Node to search in for first focusable
     */

  }, {
    key: '_setFocusToFirstItem',
    value: function _setFocusToFirstItem(node) {
      var focusableChildren = this._getFocusableChildren(node);
      if (focusableChildren.length) focusableChildren[0].focus();
    }

    /**
     * Checks if scrollbar is visible.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_checkScrollbar',
    value: function _checkScrollbar() {
      var fullWindowWidth = window.innerWidth;

      this.bodyIsOverflowing = this.body.clientWidth < fullWindowWidth;
      this.scrollbarWidth = this._measureScrollbar();
    }

    /**
     * Sets the scrollbar padding offset on the body element.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_setScrollbar',
    value: function _setScrollbar() {
      var bodyPadding = parseInt(this.body.style.paddingRight || 0, 10);

      this.originalBodyPadding = this.body.style.paddingRight || '';

      if (this.bodyIsOverflowing) {
        this.body.style.paddingRight = '' + bodyPadding + this.scrollbarWidth + 'px';
      }
    }

    /**
     * Resets the padding on the body to the way it was with the scrollbar.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_resetScrollbar',
    value: function _resetScrollbar() {
      this.body.style.paddingRight = this.originalBodyPadding;
    }

    /**
     * Measures the width of the scrollbar.
     * Ported from the bootstrap v3.3.6.
     *
     * @return {Number} Width of the scrollbar.
     */

  }, {
    key: '_measureScrollbar',
    value: function _measureScrollbar() {
      var scrollDiv = document.createElement('div');
      // Injects some styling to the element which forces the display of a scroll
      // bar and places it off the page to ensure it is never visible.
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';

      this.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      this.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }

    /**
     * Show the modal with optional eventType identifier
     * @param  {String} eventType An identifier string to pass into the onShow
     *                            callback method.
     */

  }, {
    key: 'show',
    value: function show(eventType) {
      this.shown = true;
      this._checkScrollbar();
      this._setScrollbar();
      this.body.setAttribute(this.namespace + '-open', '');
      this.node.removeAttribute('aria-hidden');
      this.main.setAttribute('aria-hidden', 'true');
      this.focusedBeforeDialog = document.activeElement;
      this._setFocusToFirstItem(this.node);
      eventType = eventType || OPEN_EVENT.METHOD;

      if (this.config.options.onShow) {
        this.config.options.onShow(eventType);
      }
    }

    /**
     * Hide the modal
     * @param  {String} eventType An identifier string to pass into the onHide
     *                            callback method.
     */

  }, {
    key: 'hide',
    value: function hide(eventType) {
      this.shown = false;
      this._resetScrollbar();
      this.body.removeAttribute(this.namespace + '-open', '');
      this.node.setAttribute('aria-hidden', 'true');
      this.main.removeAttribute('aria-hidden');
      this.focusedBeforeDialog.focus();

      if (this.config.options.onHide) {
        this.config.options.onHide(eventType);
      }
    }

    /**
     * Dynamically change the template of the modal given the new template.
     * Use this if you want to change the content without creating a new modal
     * as this does not automatically hide the new content upon replacement
     *
     * @param  {Object} content Content object to inject in the modal.
     */

  }, {
    key: 'replaceTemplate',
    value: function replaceTemplate(content) {
      var newModalContent = scaffold({
        uiIcon: uiIcon,
        id: this.config.id,
        hideModal: false,
        header: content.header,
        body: content.body,
        footer: content.footer,
        closeButton: this.config.options.closeButton,
        backdropClose: this.config.options.backdropClose,
        extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
      });

      // convert content to nodes
      var newModal = document.createElement('div');
      newModal.innerHTML = newModalContent;
      var newTemplate = newModal.childNodes[0];

      // replace with new template
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(newTemplate.children, function (child) {
        var childNode = child instanceof Node ? child : document.createTextNode(String(child));
        fragment.appendChild(childNode);
      });

      this.node.replaceChild(fragment, this.node.children[0]);

      // bind modal events
      this.node = document.getElementById(this.config.id);
      this._bindEventsToModal();
    }
  }]);

  return Modal;
}();

// This allows Webapp Modals to be used from the SystemJS (static/modules) code.
var webappCompatModalsReady = new Promise(function (resolve) {
  if (window.webappCompatModals) {
    resolve();
  } else {
    window.webappCompatModalsReadyCallback = function () {
      return resolve();
    };
  }
});

var WebappModals = function () {
  function WebappModals() {
    _classCallCheck(this, WebappModals);
  }

  _createClass(WebappModals, [{
    key: "open",
    value: function open(componentName, config, afterCloseCallback) {
      return webappCompatModalsReady.then(function () {
        return window.webappCompatModals.open(componentName, config, afterCloseCallback);
      });
    }
  }]);

  return WebappModals;
}();

// e.g.,
// webappModals.open('AwardModalComponent',
//   inputs: {
//     userId: 233223243,
//   }
// );
var webappModals = new WebappModals();

// This file has not been updated to include the updated values for each const and also new consts.
// See /modules/search/constants/deloitte.js for the latest values.
var DeloitteProjectType = {
  client_billable: 'Client Billable',
  firm_initiative: 'Firm Initiative',
  internal_services: 'Internal Services',
  PRD: 'PRD',
  skills_based_volunteering: 'Skills-Based Volunteering',
  other_investment: 'Other Investment'
};

var DeloittePractice = {
  commercial_core: 'Commercial Core',
  commercial_usdc_onsite: 'Commercial PDM',
  commercial_usdc_incenter: 'Commercial USDC',
  gps_core: 'GPS Core',
  gps_operational_excellence: 'GPS Operational Excellence (OpX)',
  gps_usdc_onsite: 'GPS PDM',
  gps_usdc_incenter: 'GPS USDC',
  usi_offshore: 'Comm USI Offshore',
  usi_onsite: 'Comm USI Onsite',
  gps_usi_offshore: 'GPS USI Offshore',
  gps_usi_onsite: 'GPS USI Onsite',
  commercial_ardc: 'Commercial ARDC'
};

var DeloitteIndustry = {
  automotive: 'Automotive',
  banking_and_capital_markets: 'Banking & Capital Markets',
  civil_government: 'Civil Government',
  consumer_products: 'Consumer Products',
  cross_sector_c: 'Cross Sector (C)',
  cross_sector_ci: 'Cross Sector (CI)',
  cross_sector_eri: 'Cross Sector (ERI)',
  cross_sector_fs: 'Cross Sector (FS)',
  cross_sector_gps: 'Cross Sector (GPS)',
  cross_sector_lshc: 'Cross Sector (LSHC)',
  cross_sector_tmt: 'Cross Sector (TMT)',
  defense_security_and_justice: 'Defense Security & Justice',
  federal_health: 'Federal Health',
  health_care: 'Health Care',
  industrial_products_and_construction: 'Industrial Products & Construction',
  insurance: 'Insurance',
  investment_management: 'Investment Management',
  media_and_entertainment: 'Media & Entertainment',
  oil_gas_and_chemicals: 'Oil, Gas, & Chemicals',
  power_and_utilities: 'Power & Utilities',
  real_estate: 'Real Estate',
  retail_wholesale_and_distribution: 'Retail, Wholesale, & Distribution',
  state_local_and_higher_education: 'State, Local, & Higher Education',
  technology: 'Technology',
  telecom_media_and_entertainment: 'Telecom, Media, & Entertainment',
  transportation_hospitality_and_services: 'Transportation, Hospitality, & Services'
};

var DeloitteOffering = {
  cbo: {
    cbo_cloud_engineering: 'Cloud Engineering',
    cbo_core_industry_solutions: 'Core Industry Solutions',
    cbo_cross_consulting_group: 'Cross Consulting Group',
    cbo_health_technology: 'Health Technology',
    cbo_operations_transformation: 'Operations Transformation',
    cbo_systems_engineering: 'Systems Engineering',
    cbo_other: 'Other'
  },
  cnm: {
    cnm_advertising_marketing_and_commerce: 'Advertising, Marketing, & Commerce',
    cnm_asset_group: 'Asset Group',
    cnm_cross_consulting_group: 'Cross Consulting Group',
    cnm_customer_strategy_and_applied_design: 'Customer Strategy & Applied Design',
    cnm_digital_customer: 'Digital Customer',
    cnm_human_services_transformation: 'Human Services Transformation',
    cnm_other: 'Other'
  },
  eo: {
    eo_asset_group: 'Asset Group',
    eo_cross_consulting_group: 'Cross Consulting Group',
    eo_erp_saas: 'Emerging ERP Solutions',
    eo_finance_and_enterprise_performance: 'Finance & Enterprise Performance',
    eo_oracle: 'Oracle',
    eo_sap: 'SAP',
    eo_supply_chain_and_network_operations: 'Supply Chain & Network Operations',
    eo_technology_services_optimization: 'Technology Services Optimization',
    eo_other: 'Other'
  },
  hc: {
    hc_asset_group: 'Asset Group',
    hc_cross_consulting_group: 'Cross Consulting Group',
    hc_hc_as_a_service: 'HC as a Service',
    hc_hr_transformation: 'HR Transformation',
    hc_organization_transformation: 'Organization Transformation',
    hc_workforce_transformation: 'Workforce Transformation',
    hc_other: 'Other'
  },
  is: {
    is_gps_business_services: 'GPS Business Services',
    is_gps_business_systems: 'GPS Business Systems',
    is_gps_compliance: 'GPS Compliance',
    is_gps_contracts: 'GPS Contracts',
    is_gps_finance: 'GPS Finance',
    is_gps_ops_management: 'GPS Ops Management',
    is_gps_security: 'GPS Security',
    is_gps_talent: 'GPS Talent'
  },
  mna: {
    mna_ccg: 'CCG',
    mna_mergers_and_acquisitions: 'MAR Strategy & Diligence',
    mna_integration_and_divesture: 'MAR Integration & Divesture ',
    mna_other: 'Other'
  },
  nc: {
    nc_adjustments_or_other: 'Adjustments/Other',
    nc_alliances: 'Alliances',
    nc_c_suite: 'C Suite',
    nc_client_and_industry: 'Client & Industry',
    nc_client_excellence: 'Client Excellence',
    nc_cloud: 'Cloud',
    nc_corporate_development: 'Corporate Development',
    nc_delivery_excellence: 'Delivery Excellence',
    nc_dtoc: 'DTOC',
    nc_international: 'International',
    nc_n_o_global_consulting_office: 'N.O Global Consulting Office',
    nc_national_consulting: 'National Consulting',
    nc_offering_portfolio: 'Offering Portfolio',
    nc_operation_and_finance: 'Operation & Finance',
    nc_other_usi: 'Other USI',
    nc_partner_matters: 'Partner Matters',
    nc_sales_and_pursuit_excellence: 'Sales & Pursuit Excellence',
    nc_strategy: 'Strategy',
    nc_talent: 'Talent',
    nc_tech_and_innovation: 'Tech & Innovation'
  },
  p: {
    p_organic: 'Organic',
    p_snet: 'SNET'
  },
  sna: {
    sna_analytics_and_cognitive: 'Analytics & Cognitive',
    sna_asset_group: 'Asset Group',
    sna_cross_consulting_group: 'Cross Consulting Group',
    sna_hybrid_solutions_and_incubation: 'Hybrid Solutions & Incubation',
    sna_strategy: 'Strategy',
    sna_other: 'Other'
  }
};

var DeloitteOfferingPortfolio = {
  cbo: 'Core Business Operations',
  cnm: 'Customer & Marketing',
  eo: 'Enterprise Performance',
  hc: 'Human Capital',
  is: 'Internal Services',
  mna: 'Mergers & Acquisitions',
  nc: 'National Consulting',
  p: 'Platforms',
  sna: 'Strategy & Analytics'
};

var LOCALSTORAGE_KEY = 'HIREME_DRAFT_';

var HireMeDraft = function () {
  function HireMeDraft() {
    _classCallCheck(this, HireMeDraft);
  }

  _createClass(HireMeDraft, [{
    key: 'get',
    value: function get(employerId, freelancerId) {
      if (!Modernizr.localstorage) {
        return;
      }

      var data = JSON.parse(localStorage.getItem('' + LOCALSTORAGE_KEY + employerId));

      if (!(data && data.freelancerId === parseInt(freelancerId, 10))) {
        return;
      }

      return data;
    }
  }, {
    key: 'save',
    value: function save(employerId, freelancerId, data) {
      if (!Modernizr.localstorage) {
        return;
      }

      data.freelancerId = parseInt(freelancerId, 10);
      localStorage.setItem('' + LOCALSTORAGE_KEY + employerId, JSON.stringify(data));
    }
  }, {
    key: 'remove',
    value: function remove(employerId, freelancerId) {
      if (!Modernizr.localstorage) {
        return;
      }

      if (this.get(employerId, freelancerId)) {
        localStorage.removeItem('' + LOCALSTORAGE_KEY + employerId);
      }
    }
  }]);

  return HireMeDraft;
}();

function hireMeDraft () {
  return new HireMeDraft();
}

var initialDataFiles = [];

function init$2(initFiles, params) {
  var fileUrl = '/buyers/postproject-upload.php?fileset=';

  params = jq.extend({
    // default template names, to not break existing pages
    uploadTemplate: 'template-upload',
    downloadTemplate: 'template-download',
    domID: 'fileupload', // id of the fileupload element to use
    domEl: document // container the fileupload element will be found in
  }, params);

  if (Object.prototype.toString.call(initFiles) === '[object Array]') {
    initialDataFiles = initFiles;
  }

  // falls back to document > #fileupload, as per default
  var domEl = jq(params.domEl);
  var fileuploadDom = domEl.find('#' + params.domID);

  // Initialize the jQuery File Upload widget:
  fileuploadDom.fileupload({
    maxFileSize: 20000000, // 20 MB
    dataType: 'json',
    dropZone: fileuploadDom,
    url: fileUrl,
    singleFileUploads: false,
    autoUpload: true,
    paramName: 'upload[]',
    uploadTemplateId: params.uploadTemplate,
    downloadTemplateId: params.downloadTemplate,
    add: function add(e, data) {
      var isUploaded = false;
      var uploadedFileNames = [];
      for (var i = 0; i < data.files.length; i++) {
        if (jq('#project_files [value=\'' + data.files[i].name + '\']').length > 0 || initialDataFiles.length > 0 && initialFileExists(data.files[i].name) === true) {
          uploadedFileNames.push(data.files[i].name);
          isUploaded = true;
        }
      }
      if (isUploaded) {
        domEl.find('.fileUploadError').text(translate('Tayari umeshapakia <%= filenames %>', {
          filenames: uploadedFileNames.join(', ') })).fadeIn().delay(2000).fadeOut('slow');
        return false;
      }
      var that = jq(this).data('fileupload');
      var options = that.options;
      var files = data.files;
      jq(this).fileupload('process', data).done(function () {
        that._adjustMaxNumberOfFiles(-files.length);
        data.isAdjusted = true;
        data.isValidated = that._validate(files);
        data.files.valid = data.isValidated;
        data.context = that._renderUpload(files).data('data', data);
        options.filesContainer[options.prependFiles ? 'prepend' : 'append'](data.context);

        that._renderPreviews(files, data.context);
        that._forceReflow(data.context);
        that._transition(data.context).done(function () {
          if (that._trigger('added', e, data) !== false && (options.autoUpload || data.autoUpload) && data.autoUpload !== false && data.isValidated) {
            data.submit();
          }
        });
      });
    },
    destroy: function destroy(e, data) {
      var fileName = jq(data.context.context).closest('.delete').siblings('.name').find('p').text().trim();
      if (fileName == '') {
        fileName = jq(data.context.context).closest('.delete').siblings('.name').text().trim();
      }
      var that = jq(this).data('fileupload');
      if (data.url) {
        jq.ajax(data);
        that._adjustMaxNumberOfFiles(1);
      }
      that._transition(data.context).done(function () {
        jq(this).remove();
        that._trigger('destroyed', e, data);
      });

      domEl.find('#project_files [value=\'' + fileName + '\']').remove();

      var driveFileElem = domEl.find('[data-upload-field="drive_files"] [data-filename="' + fileName + '"]');

      var driveFileId = driveFileElem.data('file-id');

      driveFileElem.remove();
      if (driveFileId && getUserIdfromCookie()) {
        fetch('/ajax/files/deleteFile.php?id=' + driveFileId, {
          credentials: 'same-origin',
          headers: new Headers({
            'X-XSRF-TOKEN': getCSRFToken() }),

          method: 'DELETE' });
      }
    }
  });

  // override to get DND to work for IE
  fileuploadDom.unbind('dragover').bind('dragover', function (e) {
    var that = fileuploadDom.data('fileupload');
    var dataTransfer = e.originalEvent.dataTransfer;
    e.dataTransfer = dataTransfer;
    if (that._trigger('dragover', e) === false) {
      return false;
    }
    if (dataTransfer) {
      try {
        // workaround for IE
        dataTransfer.effectAllowed = 'copy';
      } catch (_error) {
        // do nothing
      }
      dataTransfer.dropEffect = 'copy';
    }
    e.preventDefault();
  });

  fileuploadDom.bind('fileuploadadd', function (e, data) {
    data.url = fileUrl + domEl.find('#proj_upload_fileset').val();
  }).bind('fileuploaddone', function (e, data) {
    jq.each(data.result, function (index, file) {
      domEl.find('#proj_upload_fileset').val(file.fileset);

      domEl.find('#project_files').append(jq('<option/>', {
        value: file.name,
        text: file.name,
        selected: true }));

      if (file.isDriveFile) {
        domEl.find('[data-upload-field="drive_files"]').append(jq('<option/>', {
          value: file.id,
          text: file.name,
          selected: true,
          'data-file-id': file.id,
          'data-filename': file.name }));
      }
    });
  });

  fileuploadDom.find('input').attr('title', translate('Hakuna faili zilizochaguliwa.'));
}

function initialFileExists(filename) {
  if (initialDataFiles.indexOf(filename) >= 0) {
    return true;
  }

  return false;
}

var fileupload = {
  init: init$2 };

var url = '/api/users/0.1/users/check/?recommend_name=true';
var dfd = jq.Deferred();
var isAsync = true;

function init$3(asyncParam) {
  if (typeof asyncParam !== 'undefined') {
    isAsync = !!asyncParam;
  }
}

function suggestUsername(emailInput) {
  var emailData = {
    user: {
      email: emailInput
    }
  };

  jq.ajax({
    url: url,
    contentType: 'application/json; charset=utf-8',
    type: 'POST',
    data: JSON.stringify(emailData),
    dataType: 'json',
    async: isAsync
  }).success(function (response) {
    if (response.status === 'success') {
      dfd.resolve(response);
    } else {
      dfd.reject(response);
    }
  });

  return dfd.promise();
}

var usernameSuggester = {
  suggestUsername: suggestUsername,
  init: init$3
};

var _templateObject = _taggedTemplateLiteral(['^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\n    \\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]\n    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'], ['^(([^<>()\\\\[\\\\]\\\\\\.,;:\\\\s@"]+(\\\\.[^<>()\\\\[\\\\]\n    \\\\\\.,;:\\\\s@"]+)*)|(".+"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]\n    {1,3}])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$']);

/*
 * Opposite to ajax/check-email-blocked.php
 * Returns Promise
 * - If Email is Blocked, return true
 * - If Email is not Blocked, return false
 */
function isBlockedEmail(email) {
  var encodedEmail = encodeURIComponent(email);
  return fetch('/ajax/check-email-blocked.php?email=' + encodedEmail).then(function (response) {
    return response.text();
  }).then(function (response) {
    if (response == 'true') {
      return false;
    }
    return true;
  });
}

var _templateObject$1 = _taggedTemplateLiteral(['Anwani hii ya  barua pepe imezibwa. Tafadhali tumia anwani tofauti.'], ['Anwani hii ya  barua pepe imezibwa. Tafadhali tumia anwani tofauti.']);

var usernamePattern = /^[a-z][a-z0-9]{2,15}$/i;
var usernameMin = 3;
var usernameMax = 16;
var isUserReturned = false;
var loginAjax = false;
var loginCallback = false;
var domClass = {
  authFormAlert: '.auth-form-alert',
  authFormError: '.auth-form-error',
  formStep: 'control-group',
  formStepSelector: '.control-group',
  success: 'success',
  successSelector: '.success',
  error: 'error',
  errorSelector: '.error',
  warning: 'warning',
  warningSelector: '.warning',
  formError: 'help-inline',
  formErrorSelector: '.help-inline',
  formHelp: 'help-inline',
  formHelpSelector: '.help-inline' };

var signupModalRequired = void 0;
var previousEmailValidated = void 0;

var isPPP = window.isPPP;

function init$4(params) {
  signupModalRequired = params.signupModalRequired;

  jq(document).ready(function () {
    // Auth window
    jq('.authTypeBtn').click(function () {
      jq(this).siblings('.authTypeBtn').find('input').attr('checked', false);
      jq(this).find('input').attr('checked', true);
      jq('.authTypeBtn').removeClass('bold');
      jq(this).addClass('bold');

      if (jq(this).find('input').val() == 'userTypeNew') {
        jq('#userTypeReturningDiv').hide();
        jq('#projectLoginUserCreate').show();
      } else {
        jq('#projectLoginUserCreate').hide();
        jq('#userTypeReturningDiv').show();
      }

      // Clear Authform Errors
      clearAuthFormMessages();
    });

    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq('#nonAuthForm').on('click', '#loginLinkPrefill', function () {
        showPrefilledLoginForm();
      });
    }

    jq('#nonAuthForm input').focus(function (event) {
      var element = event.currentTarget;
      var controlGroupDom = jq(element).closest(domClass.formStepSelector);
      // Occurs only in PPP
      if (controlGroupDom.length > 0) {
        if (typeof isPPP !== 'undefined' && isPPP) {
          controlGroupDom.removeClass(domClass.successSelector + ' ' + (domClass.errorSelector + ' ' + domClass.error + ' ') + 'is-warning').find(domClass.formErrorText).html('');
        } else {
          controlGroupDom.removeClass(domClass.successSelector + ' ' + domClass.errorSelector).find(domClass.formErrorSelector).html('');
        }
      }
    });

    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq('#nonAuthForm').on('keyup', '#passwd', function (event) {
        if (!jq('.password-suggestion-widget').hasClass('hide')) {
          var element = event.target;
          if (jq(element).valid()) {
            var controlGroupDom = jq(element).closest(domClass.formStepSelector);

            controlGroupDom.removeClass(domClass.successSelector + ' ' + (domClass.errorSelector + ' is-warning')).find(domClass.formErrorText).html('');
          }
          if (jq(element).val() === '') {
            updatePasswordHelp({}, false);
          }
        }
      });
    }

    var validateRules = {
      // Returning user
      username: {
        required: '#userTypeReturning:checked' },

      passwd: {
        required: '#userTypeReturning:checked',
        verifyUser: true },

      // New User
      newusername: {
        required: '#userTypeNew:checked',
        rangelength: [usernameMin, usernameMax],
        checkNewUsernamePattern: true },

      email: {
        required: '#userTypeNew:checked',
        email: true },

      newuserpasswd: {
        required: '#userTypeNew:checked',
        usernamePasswordEqualCheck: '#new-username',
        checkPasswordPattern: true },

      newuserpasswd1: {
        required: '#userTypeNew:checked',
        equalTo: '#nonAuthForm #passwd' } };

    // Only occurs in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      validateRules.newuserpasswd1 = {
        required: '#userTypeNew:checked #passwd',
        equalTo: '#nonAuthForm #passwd' };
    }

    if (typeof params === 'object') {
      if (params.noConfirmPassword) {
        delete validateRules.newuserpasswd1;
      }
      if (params.useFLStyle) {
        domClass = {
          authFormAlert: '.auth-form-alert',
          authFormError: '.auth-form-error',
          formStep: 'form-step',
          formStepSelector: '.form-step',
          success: 'is-valid',
          successSelector: '.is-valid',
          error: 'is-invalid',
          warningOrange: 'is-warning',
          errorSelector: '.is-invalid',
          warning: 'is-help',
          warningSelector: '.is-help',
          formError: 'form-error',
          formErrorSelector: '.form-error',
          formErrorText: '.error-text',
          formHelp: 'form-help',
          formHelpSelector: '.form-help' };
      }

      if (params.isReturningUser) {
        jq('#userTypeReturning').attr('checked', 'true');
        jq('#userTypeReturningDiv').show();
        jq('#projectLoginUserCreate').hide();
      }

      if (params.trackNewEmail) {
        jq('#new-email').on('emailValid', function () {
          var previousEmailBuffer = typeof previousEmailValidated === 'object' ? previousEmailValidated : [];

          var validNewEmail = jq(this).val();

          if (previousEmailBuffer.indexOf(validNewEmail) === -1) {
            _lt.push(['emails_captured', {
              email: validNewEmail }]);

            previousEmailBuffer.push(validNewEmail);
          }

          previousEmailValidated = previousEmailBuffer;
        });
      }

      if (typeof params.loginCallback === 'function') {
        loginCallback = params.loginCallback;
      }
    }

    var form = jq('#nonAuthForm');
    form.on('submit', function (e) {
      e.preventDefault();
    });

    form.validate({
      errorElement: 'span',
      onsubmit: false,
      onkeyup: false,
      onfocusout: function onfocusout(element) {
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq(element).parent('li').removeClass(domClass.error + ' ' + (domClass.warningOrange + ' ') + ('' + domClass.success));

          if (jq(element).val() === '') {
            if (jq(element).attr('id') === 'passwd1' && jq('#passwd').val() !== '') {
              jq(element).valid();
            }
            return;
          }
          // Only trigger the authentication if the password is not empty.
        } else if (element.id === 'post-proj-username' && jq('#post-proj-pwd').val() === '') {
          return;
        }
        // End of AB Test
        // Validate first the patterns before submitting it to the server.
        if (jq(element).valid()) {
          if (element.id === 'new-username') {
            verifyNewUsername();
          } else if (element.id === 'new-email') {
            verifyNewEmail();
          }
        }
      },
      errorPlacement: function errorPlacement(error, element) {
        // AB Test UX Improvements 2
        if (typeof isPPP !== 'undefined' && isPPP) {
          var errorText = element.siblings(domClass.formErrorSelector).find(domClass.formErrorText);
          error.appendTo(errorText);
        } else {
          error.appendTo(element.siblings(domClass.formErrorSelector));
        }
        // End of AB Test
      },

      rules: validateRules,
      messages: {
        newusername: {
          rangelength: translate('Jina la utumiaji ni sharti liwe na herufi 3 hadi 16.') },

        newuserpasswd: {
          rangelength: translate('Jina la Siri ni sharti liwe na herufi 6 hadi 16.') } },

      highlight: function highlight(label) {
        var controlGroupDom = jq(label).closest(domClass.formStepSelector);
        controlGroupDom.removeClass(domClass.success);
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          controlGroupDom.addClass(domClass.warningOrange);
        } else {
          controlGroupDom.addClass(domClass.error);
        }
      },
      unhighlight: function unhighlight(element, errorClass) {
        if (element.type === 'radio') {
          this.findByName(element.name).removeClass(errorClass + ' ' + domClass.warningOrange);
        } else {
          jq(element).closest(domClass.formStepSelector).removeClass(errorClass + ' ' + domClass.warningOrange);
        }
      },
      success: function success(label) {
        // Only occurs in PPP
        jq(label).closest(domClass.formStepSelector).removeClass(domClass.warning + ' ' + domClass.error);
      }
    });

    jq.validator.addMethod('verifyUser', function () {
      verifyuser();
      return true;
    });

    jq.validator.addMethod('checkNewUsernamePattern', function (value, element) {
      var pattern = usernamePattern;

      if (pattern.test(jq(element).val())) {
        return true;
      }
    }, translate('Jina la utumiaji ni sharti liwe na alfabeti ama nambari na lianze na herufi.'));

    jq.validator.addMethod('checkPasswordPattern', function (value, element) {
      var val = jq(element).val();

      var nums = val.match(/\d/g);
      var lowers = val.match(/[a-z]/g);
      var uppers = val.match(/[A-Z]/g);
      var pattern = /^.{6,}$/i;

      var patternResult = pattern.test(val);

      if (patternResult) {
        var strengthLevel = 0;
        if (nums) {
          strengthLevel += 2;
        }
        if (lowers) {
          strengthLevel += uppers ? 4 : 3;
        }
        if (uppers) {
          strengthLevel += lowers ? 4 : 3;
        }
        if (strengthLevel > 4) {
          // Occurs only in PPP
          if (typeof isPPP !== 'undefined' && isPPP) {
            updatePasswordHelp({
              'help-text-num': nums,
              'help-text-upper': uppers,
              'help-text-six': patternResult }, false);
          }
          // Password Valid: Show Success
          jq('#passwd').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error).addClass(domClass.success);
          return true;
        }
      }

      // Occurs only in PPP
      if (typeof isPPP !== 'undefined' && isPPP) {
        updatePasswordHelp({
          'help-text-num': nums,
          'help-text-upper': uppers,
          'help-text-six': patternResult }, true);
      }
    }, translate('Tafadhali weka jina la siri lililo imara.'));

    jq.validator.addMethod('usernamePasswordEqualCheck', function (value, element, params) {
      var $checkElement = jq(params);

      if ($checkElement.length === 0 || $checkElement.val() == '') {
        return true;
      }

      if (value === $checkElement.val()) {
        return false;
      }

      return true;
    }, translate('Jina la Siri ni sharti lisitoshane na la Utumiaji'));

    jq('#post-proj-pwd').keypress(function (e) {
      if (e.which == 13) {
        jq('#nonAuthForm').valid();
      }
    });

    if (signupModalRequired) {
      jq('#normalLoginBtn').click(function () {
        jq('#nonAuthForm').valid();
      });
    }

    jq('#nonAuthForm').bind('validateForm', validateForm);

    var userTypeIdChecked = jq('[name=userType]:checked');
    if (userTypeIdChecked.length > 0) {
      userTypeIdChecked.click();
    }
  });
}

function updatePasswordHelp(params, showHelpBox) {
  jq.each(params, function (id, value) {
    if (value) {
      jq('#' + id).removeClass('is-invalid').addClass('is-valid');
    } else {
      jq('#' + id).removeClass('is-valid').addClass('is-invalid');
    }
  });

  if (showHelpBox) {
    jq('.password-suggestion-widget').removeClass('is-widget-hidden hide').addClass('is-visible');
    jq('.is-visible').fadeIn(function () {
      jq(this).css('display', '');
    });
  } else {
    setTimeout(function () {
      jq('.password-suggestion-widget').removeClass('is-visible').addClass('is-widget-hidden');
      jq('.is-widget-hidden').fadeOut();
    }, 400);
  }
}

function autofillUsername() {
  usernameSuggester.init();
  var emailInput = jq('#new-email').val();
  var suggestUsername = '';

  usernameSuggester.suggestUsername(emailInput).done(function (resp) {
    suggestUsername = resp.result.recommended_name;
    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq(domClass.formErrorSelector).find(domClass.formErrorText).html('');
    } else {
      jq(domClass.formErrorSelector).html('');
    }
    jq('.username').removeClass('error');
    jq('#new-username').val(suggestUsername);
    jq('#new-username').focus();
  });
}

function verifyNewEmail() {
  jq.ajax({
    dataType: 'json',
    url: '/ajax/check-email-exist.php?' + ('json=true&email=' + encodeURIComponent(jq('#new-email').val())),
    success: function success(response) {
      if (response.result == 'success') {
        (function () {
          autofillUsername();
          var suggestedEmailId = 'suggested-email';
          jq('#new-email').mailcheck({
            suggested: function suggested(element, suggestion) {
              jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error).addClass(domClass.success);
              var emailSuggestionLink = '<a id="' + suggestedEmailId + '" class="suggestedEmail" href="#">' + (suggestion.address + '@' + suggestion.domain + '</a>');
              var emailSuggestionText = translate('Ulimaanisha <%=emailSuggestion%> ?', {
                emailSuggestion: emailSuggestionLink });

              jq('#new-email').siblings(domClass.formHelpSelector).html(emailSuggestionText);

              // Add Event Listener to User Clicking on the Suggested Email
              document.getElementById(suggestedEmailId).addEventListener('click', function (event) {
                var newEmailEl = document.getElementById('new-email');
                newEmailEl.value = event.srcElement.textContent;
                newEmailEl.focus();
              });
            },
            empty: function empty() {
              // Only occurs in PPP
              if (typeof isPPP !== 'undefined' && isPPP) {
                jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error);
              } else {
                // Email is Valid. Now also check whether Email is Blocked
                isBlockedEmail(jq('#new-email').val()).then(function (result) {
                  if (result == false) {
                    jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.warning).removeClass(domClass.error).addClass(domClass.success);
                    jq('#new-email').trigger('emailValid');
                    return;
                  }
                  jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.success).removeClass(domClass.warning).addClass(domClass.error);
                  jq('#new-email').siblings(domClass.formErrorSelector).html(translate(_templateObject$1));
                }).catch(function () {
                  jq('#new-email').trigger('emailValid');
                });
              }
              jq('#new-email').siblings(domClass.formHelpSelector).html('');
            }
          });

          jq('#new-email').trigger('emailValid');
        })();
      } else {
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.success).addClass(domClass.warningOrange);
        } else {
          jq('#new-email').closest(domClass.formStepSelector).removeClass(domClass.success).addClass(domClass.error);
        }
        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          if (response.msg === 'This email already exists, please choose another') {
            jq('#new-email').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html(translate('Anwani ya barua pepe tayari ipo. <a id=\'loginLinkPrefill\'>Ingia badala yake?</a>'));
          }
        } else {
          jq('#new-email').siblings(domClass.formErrorSelector).html(translate('Anwani hii ya barua pepe tayari inatumika'));
        }
      }
    }
  });
}

function showPrefilledLoginForm() {
  jq('#userTypeReturning').attr('checked', 'true');
  jq('#post-proj-username').val(jq('#new-email').val());
  jq('.authTypeBtn').trigger('click');
  jq('#post-proj-pwd').focus();
}

function verifyNewUsername() {
  jq.ajax({
    dataType: 'json',
    url: '/ajax/check-username-exist.php?json=true&' + ('username=' + jq('#new-username').val()),
    success: function success(response) {
      var controlGroupDom = jq('#new-username').closest(domClass.formStepSelector);

      // Only occurs in PPP
      if (typeof isPPP !== 'undefined' && isPPP) {
        controlGroupDom.removeClass(domClass.error + ' ' + domClass.warningOrange).removeClass(domClass.success);
      } else {
        controlGroupDom.removeClass(domClass.error).removeClass(domClass.success);
      }

      if (response.result == 'success') {
        // does not occur in PPP
        if (typeof isPPP === 'undefined' || !isPPP) {
          controlGroupDom.addClass(domClass.success);
        }
        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq('#new-username').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html('');
        } else {
          jq('#post-proj-username').siblings(domClass.formErrorSelector).html(translate('Tafadhali angalia maelezo yako ya kuingia.'));
        }
        // Only occurs in PPP
      } else if (typeof isPPP !== 'undefined' && isPPP) {
        controlGroupDom.addClass(domClass.warningOrange);
        jq('#new-username').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html(translate('Jina hili la utumiaji tayari lipo.'));
      } else {
        controlGroupDom.addClass(domClass.error);
        jq('#new-username').siblings(domClass.formErrorSelector).html(translate('Jina hili la utumiaji tayari lipo.'));
      }
    }
  });
}

function getUserDetails() {
  jq(document).ready(function () {
    jq.ajax({
      type: 'get',
      dataType: 'json',
      url: sslBaseUrl + '/ajax/postproject/userdetails.php',
      success: function success(response) {
        if (response.status === 'success') {
          if (signupModalRequired) {
            jq('#signup-modal').trigger('initialBid');
            return true;
          }
          isUserReturned = true;
          if (response.user_location !== false && typeof window.userLocation !== 'undefined' && window.userLocation === false) {
            window.userLocation = response.user_location;
          }
          var logoHTML = '<img src="' + response.logo_url + '" ' + ('alt="' + response.logoname + '" ') + 'border=0 width=80 height=80 style="margin-right: 20px;">';
          jq('#loggedinLogo').html(logoHTML);
          jq('#loggedinFullname').html(response.name);
          jq('#nonAuthForm').fadeOut('slow', function () {
            jq('#headerTopLoggedIn').fadeIn('slow');
          });
          jq('#createform').removeClass('faded');
        }
      }
    });
  });
}

function verifyuser(callback) {
  clearAuthFormMessages();

  var username = jq('#post-proj-username').val();
  var password = jq('#post-proj-pwd').val();

  if (username == '' || password == '') {
    return false;
  }

  if (!signupModalRequired) {
    jq('#returningForm').hide();
    jq('#returningAjax').show();
  } else {
    jq('#normalLoginBtn').hide();
    jq('#normal-login-spiner').show();
  }
  if (loginAjax) {
    loginAjax.abort();
  }
  loginAjax = jq.ajax({
    type: 'post',
    data: {
      username: username,
      passwd: password,
      csrf_token: getCSRFToken() },

    dataType: 'json',
    url: sslBaseUrl + '/ajax/login.php',
    cache: false,
    success: function success(response) {
      if (jq('#headerTopLoggedIn').is(':visible')) {
        return;
      }

      if (response.status == 'success') {
        if (response.redirect) {
          window.location.href = response.redirect;
        }
        jq('.terms-text, .contest_terms, .hireme-terms').hide();

        if (loginCallback && typeof loginCallback === 'function') {
          isUserReturned = true;
          loginCallback();
        } else {
          getUserDetails();
        }
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq(document).trigger('userLogin', response);
        }
      } else {
        jq('#post-proj-username, #post-proj-pwd').closest(domClass.formStepSelector).removeClass(domClass.success).addClass(domClass.error);
        var errorMsg = void 0;
        var errorAnchor = void 0;
        if (response.code === 5) {
          errorMsg = response.msg;
          errorAnchor = domClass.authFormAlert;
        } else {
          errorMsg = translate('Tafadhali angalia maelezo yako ya kuingia.');
          errorAnchor = jq('#post-proj-pwd').siblings('.help-inline');
        }

        jq(errorAnchor).html(errorMsg).show();

        if (!signupModalRequired) {
          jq('#returningForm').show();
          jq('#returningAjax').hide();
        } else {
          jq('#normalLoginBtn').show();
          jq('#normal-login-spiner').hide();
        }
      }

      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    }
  });
}

function validateForm() {
  jq(this).data('isValid', jq('#nonAuthForm').valid());
  return jq(this).data('isValid');
}

function userReturned() {
  return isUserReturned;
}

function clearAuthFormMessages() {
  jq('#post-proj-username, #post-proj-pwd').closest(domClass.formStepSelector).removeClass(domClass.success + ' ' + domClass.error);
  // Occurs only in PPP
  if (typeof isPPP !== 'undefined' && isPPP) {
    jq('#post-proj-username').siblings(domClass.formErrorSelector).find(domClass.formErrorText).html('');
  } else {
    jq('#post-proj-username').siblings(domClass.formErrorSelector).html('');
    jq('#post-proj-pwd').siblings(domClass.formErrorSelector).html('');
  }
  jq(domClass.authFormAlert).html('').hide();
  jq(domClass.authFormError).html('').hide();
}

var userAuthForm = {
  init: init$4,
  getUserDetails: getUserDetails,
  validateForm: validateForm,
  userReturned: userReturned,
  verifyUser: verifyuser,
  isSignUp: function isSignUp() {
    return jq('#userTypeNew').is(':checked');
  },

  dom: {
    getForm: function getForm() {
      return jq('#nonAuthForm');
    },
    isFormVisible: function isFormVisible() {
      return jq('#nonAuthForm:visible').length > 0;
    },
    getNewEmail: function getNewEmail() {
      return jq('#new-email');
    },
    getNewUsername: function getNewUsername() {
      return jq('#new-username');
    },
    getPassword: function getPassword() {
      return jq('#passwd');
    },
    getConfirmPassword: function getConfirmPassword() {
      return jq('#passwd1');
    }
  } };

var hiremeModalContainerTemplate = "<div class=\"pinky-template\">\n  <div class=\"quickhire-legacy\">\n    <div id=\"modal-hire-me\" class=\"quick-hire-form-container modal hide absolute\">\n    </div>\n  </div>\n</div>\n";

var quickHireFormTemplate = "<%  if (isArrowDomain === false) {  %>\n  <div id=\"quick-hire-form\" class=\"ModalHireMe quick-hire-form quick-hire-form-slim\">\n    <div id=\"headerTopLoggedIn\" class=\"ModalHireMe-loginGreeting\">\n      <div class=\"Card\">\n        <div class=\"Card-body\">\n          <div id=\"loggedinLogo\" class=\"ModalHireMe-loginGreeting-profilePicture\"></div>\n          <div id=\"loggedinWelcome\">\n            <h1 class=\"ModalHireMe-loginGreeting-title\">\n              <%= T_('Karibu tena <span id=\"loggedinFullname\"></span>!') %>\n            </h1>\n            <p><%- T_('Eleza mradi wako hapo chini.') %></p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <%  if (typeof show_hireme_promotion_copy !== 'undefined' && show_hireme_promotion_copy) {  %>\n      <div class=\"alert alert-info quick-hire-form-alert\">\n        <%- T_('Unachukia ada kuongezeka? Muajiri <[- username ]> sasa, ada za miradi hazitazidi asilimia 0% milele!', { 'username': username }) %>\n      </div>\n    <%  }  %>\n\n    <%  if (!thisUser)  {  %>\n      <form id='nonAuthForm' novalidate='novalidate' class=\"is-hidden\">\n        <fieldset >\n          <div id='returningForm'>\n\n\n              <legend><span class=\"fl-icon-user\"></span> <%- T_('Kukuhusu') %> </legend>\n\n            <div class=\"control-group account-wrapper\">\n\n              <label class=\"radio-label\"> <%- T_('Mimi ni:') %> </label>\n\n              <label class=\"radio authTypeBtn <%  if (isNewUser) {  %> bold <%  }  %>\">\n                <input\n                  type=\"radio\"\n                  id=\"userTypeNew\"\n                  value=\"userTypeNew\"\n                  name=\"userType\"\n                  <%  if (isNewUser || email != undefined) {  %> checked='checked' <%  }  %>>\n\n                  <%- T_('Mtumiaji mgeni') %>\n              </label>\n\n              <label class=\"radio authTypeBtn <%  if (!isNewUser) {  %> bold <%  }  %>\">\n                <input\n                  type=\"radio\"\n                  id=\"userTypeReturning\"\n                  value=\"userTypeReturning\"\n                  name=\"userType\"\n                  <%  if (!isNewUser) {  %> checked='checked' <%  }  %>>\n\n                  <%- T_('Mtumiaji anayerudi') %>\n              </label>\n\n            </div>\n\n            <aside class=\"auth-form-alert alert alert-warning hide\"></aside>\n            <aside class=\"auth-form-error alert alert-error hide\"></aside>\n\n            <!-- FACEBOOK OAUTH SECTION -->\n            <div id='fb_place_holder'></div>\n\n            <!-- SIGN-UP SECTION -->\n            <div id='projectLoginUserCreate' <%  if (!isNewUser) {  %> class='hide' <%  }  %>>\n              <div class=\"control-group\">\n                <div class=\"controls\">\n                <input type=\"text\" id='new-email' name='email' placeholder=\"<%- T_('Barua Pepe') %> \" value=\"<%-  email  %>\">\n                <span class=\"help-inline form-error\"></span>\n                </div>\n              </div>\n              <div class=\"control-group\">\n                <div class=\"controls\">\n                  <input\n                    type=\"text\"\n                    name=\"newusername\"\n                    maxlength=\"16\"\n                    id=\"new-username\"\n                    class=\"valid\"\n                    placeholder=\"<%- T_('Jina la Utumiaji') %> \"\n                  >\n                <span class=\"help-inline form-error\"></span>\n                </div>\n              </div>\n              <div class=\"control-group\">\n                <div class=\"controls\">\n                <input type=\"password\" id='passwd' name='newuserpasswd' placeholder=\"<%- T_('Jina la Siri') %> \">\n                <span class=\"help-inline form-error\"></span>\n                </div>\n              </div>\n            </div>\n\n            <!-- LOGIN SECTION -->\n            <div id='userTypeReturningDiv' <%  if (isNewUser) {  %> class='hide' <%  }  %>>\n                <div class=\"control-group\">\n                  <div class=\"controls\">\n                  <input\n                    type=\"text\"\n                    id=\"post-proj-username\"\n                    name='username'\n                    value=\"\"\n                    size=\"45\"\n                    placeholder=\"<%- T_('Jina la Utumiaji') %>\">\n                  <span class=\"help-inline\"></span>\n                  </div>\n                </div>\n                <div class=\"control-group\">\n                  <div class=\"controls\">\n                  <input\n                    type=\"password\"\n                    id=\"post-proj-pwd\"\n                    name='passwd'\n                    value=\"\"\n                    size=\"45\"\n                    placeholder=\"<%- T_('Jina la Siri') %>\">\n                  <span class=\"help-inline\"></span>\n                  </div>\n                </div>\n            </div>\n          </div>\n        </fieldset>\n\n        <div id=\"returningAjax\">\n          <span>\n            <img src=\"<%=  cdn_url('/img/spinner-black.gif')  %>\">\n          </span>\n        </div>\n\n      </form>\n    <%  }  %>\n\n    <form class='quick-hire-post-form' data-seller-id=\"<%-  userID  %>\" data-seller-username=\"<%-  username  %>\"\n      data-source-type=\"<%-  sourceType  %>\" data-source-id=\"<%-  sourceId  %>\">\n      <fieldset>\n\n          <legend><span class=\"fl-icon-comment\"></span> <%- T_('Tuma Ujumbe wa Kibinafsi') %> </legend>\n\n        <div class=\"control-group\">\n          <div class=\"controls\">\n              <textarea\n                rows=\"3\"\n                name=\"pmb\"\n                placeholder=\"<%- T_('Waambie machache kukuhusu wewe na mradi wako, na ujumuishe maelezo ya kile unachohitaji kufanywa.') %>\"\n                data-draft=\"pmb\"\n                id=\"pmb\"\n              ><%- T_('Jambo <[- username ]>, nimeona profaili yako na ningependa kukupatia mradi wangu. Tutaweza kujadiliana maelezo yoyote kwa chat.', { 'username': username }) %></textarea>\n          <span class=\"help-block\"></span>\n          </div>\n        </div>\n      </fieldset>\n      <%  if (!isDeloitteUser)  {  %>\n      <fieldset class=\"ModalHireMe-budgetForm\">\n        <div class=\"ModalHireMe-budgetForm-row control-group\">\n          <div class=\"ModalHireMe-budgetForm-inputs\">\n            <select id='project-type' class=\"ModalHireMe-budgetForm-type budget-type budget-period project-type\" data-draft=\"project_type\">\n              <option value='fixed'> <%- T_('Bei Isiyobadilika') %> </option>\n              <option value='hourly'> <%- T_('Kwa Saa') %> </option>\n            </select>\n            <div class=\"controls fixed-detail\" style=\"display: inline-block\">\n              <div class=\"ModalHireMe-budgetForm-rateDuration input-append\">\n                <%= T_(\"<input type='number' name='fixedPeriod' class='ModalHireMe-budgetForm-rateDuration-input project-period' min='1' data-draft='period' value=<[-days_duration]>><span class='ModalHireMe-budgetForm-rateDuration-addOn add-on'>Siku</span>\", { days_duration: days_duration }) %>\n              </div>\n            </div>\n            <div class=\"controls hourly-detail\" style=\"display: none\">\n              <div class=\"ModalHireMe-budgetForm-rateDuration input-append\">\n                <%= T_(\"<span>ndani ya</span> <input type='number' name='commitment' class='ModalHireMe-budgetForm-rateDuration-input project-workload' min='1' value='10' data-draft='commitment'/> <span class='ModalHireMe-budgetForm-rateDuration-addOn add-on'>Saa/Wiki</span>\") %>\n              </div>\n            </div>\n          </div>\n          <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n        </div>\n\n        <div class=\"control-group project-type-detail fixed-detail hourly-detail\">\n          <label class=\"control-label\">\n            <%- T_('Bajeti') %>\n            <span class=\"normal\">\n              (<%- T_('Dakika') %>: <span class=\"min-budget-currency-sign\">$</span><span class=\"min-budget-amount\">10</span><span id=\"min-budget-per-hour\" hidden><%- T_('/saa') %></span>)\n            </span>\n          </label>\n          <div class=\"ModalHireMe-budgetForm-row\">\n            <input type='hidden' class='project-duration' value='6'>\n            <div class=\"ModalHireMe-budgetForm-inputs controls\">\n              <div class=\"input-prepend\">\n                <span class=\"add-on budget-currency-sign\">$</span><input\n                  type=\"number\"\n                  name='budget'\n                  class=\"ModalHireMe-budgetForm-amount budget-amount\"\n                  min=\"<%-  default_min  %>\"\n                  fixed-value=\"<%-  min_fixed_budget  %>\"\n                  hourly-value=\"<%-  hourlyrate  %>\"\n                  value=\"<%-  min_fixed_budget  %>\"\n                  data-draft=\"budget\">\n              </div>\n              <select id=\"modalhireme-fixed-multifield-currency\" name='currency'\n                class=\"ModalHireMe-budgetForm-currency project-currency\" data-draft=\"currency\">\n                <%  _.each(budgets, function(budget, index) {  %>\n                  <%  if (!isEscrowComRequired || (isEscrowComRequired && budget.vars.is_escrow)) {  %>\n                    <option\n                      value=\"<%-  budget.vars.currency.id  %>\"\n                      title=\"<%=  budget.vars.currency.sign  %>\"\n                      min-fixed-budget=\"<%-  budget.vars.budgets.fixed[0].min_sum  %>\"\n                      min-hourly-budget=\"<%-  budget.vars.budgets.hourly[0].min_sum  %>\"\n                      exchange-rate=\"<%-  budget.vars.currency.exchangerate  %>\"\n                      <%  if (index == 0) {  %> selected=\"selected\" <%  }  %>>\n                      <%-  budget.vars.currency.code  %>\n                    </option>\n                  <%  }  %>\n                <%  })  %>\n              </select>\n            </div>\n            <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n        </div>\n      </fieldset>\n      <%  }  %>\n      <%  if (isDeloitteUser)  {  %>\n      <!-- Show these fieldset just for Deloitte users -->\n      <fieldset class=\"ModalHireMe-budgetForm\">\n        <div class=\"ModalHireMe-Deloitte\">\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n            <label for=\"deloitteBillingCode\">\n                <%-  T_('Project Billing code')  %>\n              <span class=\"Tooltip--top\" data-tooltip=\"Billing code will not be shared with resource until they accept the project\">\n                <span class=\"ModalHireMe-Deloitte-icon fl-icon-info-sign\"></span>\n              </span>\n            </label>\n            <input id=\"deloitteBillingCode\" name=\"deloitteBillingCode\" type=\"text\" class=\"default-input\" placeholder=\"ABC12345-12-12-AB-1234\">\n            <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n            <label for=\"deloitteBillableHours\"><%- T_('Saa Zinazotarajiwa Kulipishwa') %></label>\n            <span class=\"input-group input-append ModalHireMe-Deloitte-inputWrapper\">\n                <input id=\"deloitteBillableHours\" name=\"deloitteBillableHours\" type=\"number\" class=\"default-input\" placeholder=\"1\" min=\"1\" max=\"1000\">\n                <span class=\"add-on\"><%- T_('Saa') %></span>\n            </span>\n            <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n              <label for=\"startDate\"><%- T_('Tarehe ya kuanza inayotarajiwa') %></label>\n              <input type=\"date\" name=\"startDate\" id=\"startDate\" class=\"default-input\">\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n          </div>\n          <div class=\"ModalHireMe-Deloitte-item control-group\">\n              <label for=\"endDate\"><%- T_('Tarehe ya mwisho inayotarajiwa') %></label>\n              <input type=\"date\" name=\"endDate\" id=\"endDate\" class=\"default-input\">\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n\n          </div>\n        </div>\n        <div>\n          <h3 class=\"ModalHireMe-Deloitte-subtitle \"><%- T_('Maelezo ya Mradi') %></h3>\n          <div class=\"ModalHireMe-Deloitte\">\n            <div class=\"ModalHireMe-Deloitte-item control-group\">\n                <label for=\"deloitteProjectType\"><%- T_('Aina ya mradi') %></label>\n                <select class=\"small-select\" name=\"deloitteProjectType\" id=\"deloitteProjectType\">\n                  <option value=\"\"><%- T_('Tafadhali chagua aina ya mradi') %></option>\n                  <%  for (var key in deloitteAdditionalFieldsData.DeloitteProjectType) {  %>\n                    <option value=\"<%-  key  %>\"\n                      title=<%-  deloitteAdditionalFieldsData.DeloitteProjectType[key]  %>\">\n                      <%-  deloitteAdditionalFieldsData.DeloitteProjectType[key]  %>\n                    </option>\n                  <%  };  %>\n                </select>\n                <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n            </div>\n            <div class=\"ModalHireMe-Deloitte-item control-group\">\n                <label for=\"deloittePractice\"><%-  T_('Practice')  %></label>\n                <select class=\"small-select\" name=\"deloittePractice\" id=\"deloittePractice\">\n                  <option value=\"\"><%-  T_('Please select project practice')  %></option>\n                  <%  for (var key in deloitteAdditionalFieldsData.DeloittePractice) {  %>\n                    <option value=\"<%-  key  %>\"\n                      title=<%-  deloitteAdditionalFieldsData.DeloittePractice[key]  %>\">\n                      <%-  deloitteAdditionalFieldsData.DeloittePractice[key]  %>\n                    </option>\n                  <%  };  %>\n                </select>\n                <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n            </div>\n            <div class=\"ModalHireMe-Deloitte-item control-group\">\n                <label for=\"deloitteIndustry\"><%-  T_('Industry')  %></label>\n                <select class=\"small-select\" name=\"deloitteIndustry\" id=\"deloitteIndustry\">\n                  <option value=\"\"><%-  T_('Please select project industry')  %></option>\n                  <%  for (var key in deloitteAdditionalFieldsData.DeloitteIndustry) {  %>\n                    <option value=\"<%-  key  %>\"\n                      title=<%-  deloitteAdditionalFieldsData.DeloitteIndustry[key]  %>\">\n                      <%-  deloitteAdditionalFieldsData.DeloitteIndustry[key]  %>\n                    </option>\n                  <%  };  %>\n                </select>\n                <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n            </div>\n            <div class=\"ModalHireMe-Deloitte-item control-group\">\n                <label class=\"ModalHireMe-Deloitte-portfolioWrapper\" for=\"deloitteOffering\">\n                  <%-  T_('Offering')  %>\n                  <span data-offering-category></span>\n                </label>\n                <select class=\"small-select\" name=\"deloitteOffering\" id=\"deloitteOffering\">\n                  <option value=\"\"><%-  T_('Please select project offering')  %></option>\n                  <%  for (var portfolio in deloitteAdditionalFieldsData.DeloitteOffering) {  %>\n                    <optgroup label=\"<%-  deloitteAdditionalFieldsData.DeloitteOfferingPortfolio[portfolio]  %>\">\n                      <%  var portfolioObj = deloitteAdditionalFieldsData.DeloitteOffering[portfolio];  %>\n                      <%  for (var offering in portfolioObj) {  %>\n                        <option value=\"<%-  offering  %>\"\n                          title=<%-  portfolioObj[offering]  %>\">\n                          <%-  portfolioObj[offering]  %>\n                        </option>\n                      <%  };  %>\n                    </optgroup>\n                  <%  };  %>\n                </select>\n                <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n            </div>\n            <div class=\"control-group\">\n              <div class=\"Checkbox\">\n                <input id=\"isClearanceRequired\" name=\"isClearanceRequired\" class=\"Checkbox-input\" type=\"checkbox\" >\n                <label class=\"Checkbox-label\" for=\"isClearanceRequired\"><%- T_('Je, kibali kinahitajika kwa mradi huu?') %></label>\n              </div>\n              <input id=\"deloitteClearance\" disabled name=\"deloitteClearance\" type=\"text\" class=\"default-input\" placeholder=\"Specify clearance\">\n              <div class=\"ModalHireMe-budgetForm-helper help-block\"></div>\n            </div>\n            <div class=\"control-group\">\n              <div class=\"Checkbox\">\n                <input id=\"deloitteItar\" class=\"Checkbox-input\" type=\"checkbox\" name=\"deloitteItar\">\n                <label class=\"Checkbox-label\" for=\"deloitteItar\"><%- T_('Je, mradi huu unategemea Kanuni za Kimataifa za Usafiri wa Silaha (ITAR)?') %></label>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"control-group\">\n          <div class=\"Checkbox\">\n            <input id=\"deloitteUserAgreement\" class=\"Checkbox-input\" type=\"checkbox\" name=\"deloitteUserAgreement\" required>\n            <label class=\"Checkbox-label checkbox ModalHireMe-checkbox\" for=\"deloitteUserAgreement\">\n              <span>\n                I have reviewed my project and affirm that no\n                <a href=\"/media/deloitte/confidential-information.pdf\" target=\"_blank\">confidential information</a>\n                has been shared in this project posting in compliance with Deloitte's\n                <a href=\"https://resources.deloitte.com/sites/US/About/Policies/Admin/Pages/Home.aspx?US_200_223\" target=\"_blank\">Confidentiality Policy</a>\n                and\n                <a href=\"https://resources.deloitte.com/sites/US/About/Policies/Admin/Pages/Home.aspx?US_900_910\" target=\"_blank\">Privacy Policy</a>\n              </span>\n            </label>\n          </div>\n        </div>\n      </fieldset>\n      <%  }  %>\n      <p class=\"hireme-terms\">\n        <%= T_('Kwa kubonyeza ’Ajiri Sasa’, unaashiria kuwa umesoma na unakubaliana na <a href=\"/about/terms\" class=\"site_plainterms\">Sheria na Masharti</a> na <a href=\"/about/privacy\" class=\"site_privacy\">Sera ya Faragha</a>') %>\n      </p>\n    </form>\n    <div id=\"quickhire-modal-generic-error\" class=\"quickhire-modal-generic-error alert alert-error\">\n    </div>\n    <a class=\"btn btn-info btn-block btn-quickhire\"\n      hireme-label=\"Success\"><%- T_('Ajiri Sasa!') %></a>\n    <div class=\"Loader loading-img\" style=\"display:none\"></div>\n  </div>\n  <!-- The template to display files available for upload -->\n  <script id=\"quickhire-template-upload\" type=\"text/x-tmpl\">\n  {% for (var i=0, file; file=o.files[i]; i++) { %}\n    {% var errors = <%=  JSON.stringify(locale.fileupload.errors)  %>; %}\n    <tr class=\"template-upload fade\">\n      <td class=\"preview\"><span class=\"fade\"></span></td>\n      <td class=\"name\" title=\"{%=file.name%}\">\n        <span class=\"filename-span\">{%=file.name%}</span>\n      </td>\n      <td class=\"size\"><span>{%=o.formatFileSize(file.size)%}</span></td>\n      {% if (file.error) { %}\n        <td class=\"error\" colspan=\"2\">\n          <span class=\"label label-important\"><%-  locale.fileupload.error  %></span>\n          {%=errors[file.error] || file.error%}</td>\n        <td class=\"cancel\">\n          <button class=\"btn btn-danger\">\n            <i class=\"icon-trash icon-white\"></i>\n            <span><%-  locale.fileupload.destroy  %></span>\n          </button>\n        </td>\n      {% } else if (o.files.valid && !i) { %}\n        <td>\n          <div class=\"progress progress-success progress-striped active\"\n          role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\"\n          aria-valuenow=\"0\">\n            <div class=\"bar fileupload-progress-bar\"></div>\n          </div>\n        </td>\n        <td class=\"start\">{% if (!o.options.autoUpload) { %}\n          <button class=\"btn btn-primary\">\n            <i class=\"icon-upload icon-white\"></i>\n            <span><%-  locale.fileupload.start  %></span>\n          </button>\n        {% } %}</td>\n        <td class=\"cancel\">{% if (!i) { %}\n          <button class=\"btn btn-primary\">\n            <i class=\"icon-ban-circle icon-white\"></i>\n            <span><%-  locale.fileupload.cancel  %></span>\n          </button>\n        {% } %}</td>\n      {% } else { %}\n        <td colspan=\"2\"></td>\n        <td class=\"cancel\">{% if (!i) { %}\n          <button class=\"btn btn-primary\">\n            <i class=\"icon-ban-circle icon-white\"></i>\n            <span><%-  locale.fileupload.cancel  %></span>\n          </button>\n        {% } %}</td>\n      {% } %}\n    </tr>\n  {% } %}\n  </script>\n  <!-- The template to display files available for download -->\n  <script id=\"quickhire-template-download\" type=\"text/x-tmpl\">\n  {% for (var i=0, file; file=o.files[i]; i++) { %}\n    {% var errors = <%=  JSON.stringify(locale.fileupload.errors)  %>; %}\n    <tr class=\"template-download fade\">\n      {% if (file.error) { %}\n        <td></td>\n        <td class=\"name\" title=\"{%=file.name%}\">\n          <span class=\"filename-span\">{%=file.name%}</span>\n        </td>\n        <td class=\"size\"><span>{%=o.formatFileSize(file.size)%}</span></td>\n        <td class=\"error\" colspan=\"2\">\n          <span class=\"label label-important\"><%-  locale.fileupload.error  %></span>\n          {%=errors[file.error] || file.error%}\n        </td>\n      {% } else { %}\n        <td class=\"preview\">{% if (file.thumbnail_url) { %}\n          <a href=\"{%=file.url%}\" title=\"{%=file.name%}\" rel=\"gallery\" download=\"{%=file.name%}\"><img src=\"{%=file.thumbnail_url%}\"></a>\n        {% } %}</td>\n        <td class=\"name\">\n          <p href=\"{%=file.url%}\" title=\"{%=file.name%}\"\n          rel=\"{%=file.thumbnail_url&&'gallery'%}\"\n          download=\"{%=file.name%}\">\n            <span class=\"filename-span\">{%=file.name%}</span>\n          </p>\n        </td>\n        <td class=\"size\"><span>{%=o.formatFileSize(file.size)%}</span></td>\n        <td colspan=\"2\"></td>\n      {% } %}\n      <td class=\"delete\">\n        <button class=\"btn btn-danger\" data-type=\"{%=file.delete_type%}\" data-url=\"{%=file.delete_url%}\">\n          <i class=\"icon-trash icon-white\"></i>\n          <%-  locale.fileupload.destroy  %>\n        </button>\n      </td>\n    </tr>\n  {% } %}\n  </script>\n<%  }  %>\n";

var quickHireFormTemplateHeader = "<%  if (isArrowDomain === true) {  %>\n    <h3 class=\"quick-hire-form-title\"><%-  T_('Posting new projects on ArrowPlus has been disabled.')  %></h3>\n<%  } else {  %>\n    <h3 class=\"quick-hire-form-title\"><%- T_('Mpatie <[- username ]> mradi wako', { 'username': username }) %></h3>\n<%  }  %>\n";

var quickHireMilestoneFormTemplate = "<div class=\"milestone-modal-wrapper pinky-template\">\n  <div class=\"milestone-modal is-milestone-hireme\">\n    <h3 class=\"milestone-modal-title\"><%- T_('Tunga Malipo ya Hatua') %></h3>\n    <span class=\"project-descr-tip quick-hire-post-form-tip\" data-title=\"<%- T_('Malipo ya Hatua') %>\" id=\"milestones-popover\"\n      data-content=\"<%- T_('Mfumo wa Malipo ya Hatua ni mbinu yetu ya malipo iliyolindwa. Inamruhusu <[- username]> kuanza kazi, akijua fedha ziko, na inakupatia utulivu wa moyo kwa kuwa unawachilia fedha mara utakaporidhika kwa silimia 100%. Tunapendekeza ugawanye mradi wako kwa majukumu madogo madogo (hatua) na umlipe <[- username]> kwa mikondo, wakati kila hatua inakamilika. Ikiwa kutaweza kutokea jambo kwenye mradi wako, malipo ya hatua yote yanalindwa na Mfumo wetu wa Kutatua Mgogoro.', { 'username': username }) %>\">\n      <img src=\"<%=  cdn_url('/build/css/images/pages/post-project/question.png')  %>\">\n    </span>\n    <div class=\"milestone-modal-description\">\n      <p class=\"milestone-modal-description-content\">\n        <%= T_('Wafanyakazi huru <strong> wana uwezekano wa zaidi ya asilimia 150%</strong> kukubali mradi wako ikiwa malipo ya Hatua yameundwa. Malipo yako ya hatua yatarudishwa moja kwa moja ikiwa <[- username ]> hatakubali mradi.', { 'username': username }) %>\n      </p>\n    </div>\n    <form class=\"quick-hire-milestone-form milestone-modal-form fl-form\">\n      <fieldset class=\"milestone-modal-form-fieldset\">\n        <ol>\n          <li class=\"milestone-modal-form-amount control-group form-step\">\n            <label><%- T_('Kiasi cha Hatua') %></label>\n            <span class=\"input-group\">\n              <span class=\"milestone-currency-sign add-on\">\n                <%  if (typeof abTestPrehire !== 'undefined' && abTestPrehire && currency) {  %>\n                  <%=  currency.sign  %>\n                <%  } else {  %>\n                  <%=  quickHireReturnData.currency_sign  %>\n                <%  }  %>\n              </span>\n              <input name=\"milestoneAmount\"\n                class=\"milestone-modal-form-amount-input milestone-amount default-input\"\n                type=\"text\"\n                placeholder=\"\"\n                value=\"<%-  budget  %>\"\n                maxlength=\"8\">\n            </span>\n            <div class=\"form-error help-block\"></div>\n          </li>\n          <li class=\"milestone-modal-form-description control-group form-step\">\n            <label><%- T_('Maelezo ya Hatua') %></label>\n            <input type=\"text\" name=\"milestoneDescr\" class=\"milestone-descr default-input\"\n              placeholder=\"<%- T_('Weka maelezo yako ya hatua ya malipo hapa') %>\" value=\"<%- T_('Malipo ya hatua ya awali') %>\">\n            <div class=\"form-error help-block\"></div>\n          </li>\n        </ol>\n      </fieldset>\n    </form>\n    <div id=\"milestone-modal-upgrade-section\" class=\"milestone-modal-upgrade-section is-hidden\"></div>\n    <div class=\"milestone-request-total milestone-modal-total\">\n      <%- T_('Jumla:') %>\n      <%  if (typeof abTestPrehire !== 'undefined' && abTestPrehire && currency) {  %>\n        <%=  currency.sign  %>\n      <%  } else {  %>\n        <%=  quickHireReturnData.currency_sign  %>\n      <%  }  %>\n      <span class='total-amount'>\n      </span>\n      <%  if (typeof abTestPrehire !== 'undefined' && abTestPrehire && currency) {  %>\n        <%=  currency.code  %>\n      <%  }  %>\n    </div>\n    <div class=\"milestone-modal-payment milestone-modal-summary\">\n      <div id=\"payment-sources-container\">\n      </div>\n    </div>\n    <div id=\"prehire-created\" class=\"alert alert-success hide\">\n      <%= T_('Umemuajiri <strong><[- username ]></strong> kikamilifu.', { 'username': username }) %>\n    </div>\n    <div id=\"milestone-error\" class=\"milestone-modal-alert alert alert-error\"></div>\n    <div class=\"quickhire-modal-generic-warning milestone-modal-alert alert alert-warning\"></div>\n    <%  if (typeof abTestSkipMilestone !== 'undefined' && abTestSkipMilestone) {  %>\n      <button type=\"button\" class=\"btn\" id=\"milestone-not-now\"\n        data-qtsb-section=\"HireMe\"\n        data-qtsb-subsection=\"CreateMilestoneModal\"\n        data-qtsb-label=\"NotNow\">\n        <%- T_('Sio Sasa') %>\n      </button>\n    <%  }  %>\n    <button type=\"button\" class=\"btn btn-info btn-quickhire-create-milestone\"\n      data-qtsb-section=\"HireMe\"\n      data-qtsb-subsection=\"CreateMilestoneModal\"\n      data-qtsb-label=\"Proceed\">\n      <%- T_('Elekea kwa Malipo') %>\n    </button>\n    <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img margin-r20\" style=\"display:none\"/>\n    <a type=\"button\" class=\"btn btn-quickhire-no-milestone is-hidden\"\n      href=\"<%  if (typeof abTestPrehire === 'undefined' || !abTestPrehire) {  %> <%-  quickHireReturnData.url  %> <%  } else {  %> <%  }  %>\" >\n      <%- T_('La Ahsante') %>\n    </a>\n  </div>\n</div>\n";

var paymentVerificationTemplate = "<figure class=\"ModalPaymentVerification-figure\">\n    <img src=\"/build/img/payment-verification.svg\"\n      alt=\"Keep our community safe: Verify your payment method to hire freelancers\">\n</figure>\n<h3 class=\"ModalPaymentVerification-heading\">Keep our community safe</h3>\n<p class=\"ModalPaymentVerification-copy\">Verify your payment method to hire freelancers</p>\n<div class=\"ModalPaymentVerification-cta\">\n  <a id=\"verify-now\"\n    type=\"button\"\n    href=\"<%-  paymentVerifyUrl  %>\"\n    class=\"btn btn-info btn-large ModalPaymentVerification-button\">Verify Now</a>\n</div>\n<p>\n  <a id=\"verify-later\"\n    href=\"<%-  pppRedirectUrl  %>\">Or post a project and verify later</a>\n</p>\n";

var errorMessageTemplate = "<div>\n  <%  if (code === ErrorCode.EMAIL_VERIFICATION_REQUIRED) {  %>\n    <p>\n      <strong><%- T_('Uthibitishaji wa barua pepe unahitajika') %></strong>\n    </p>\n    <p>\n      <%- T_('Unahitaji kuthibitisha barua pepe yako kabla ya kumwajiri mtumiaji huyu.') %>\n    </p>\n    <a href=\"/users/verify.php?id=<%-  userId  %>&sellerId=<%-  sellerId  %>\" target=\"_blank\">\n      <%- T_('Dhibitisha anwani pepe yako') %>\n    </a>\n  <%  } else if (code === ErrorCode.NEGATIVE_BALANCE_SUSPENSION) {  %>\n    <%=  message  %>\n  <%  } else {  %>\n    <%-  message  %>\n  <%  }  %>\n</div>\n";

var _templateObject$2 = _taggedTemplateLiteral(['#modalhireme-fixed-multifield-currency\n      option[value="', '"]'], ['#modalhireme-fixed-multifield-currency\n      option[value="', '"]']),
    _templateObject2 = _taggedTemplateLiteral(['.hourly-detail #modalhireme-fixed-multifield-currency\n            option:selected'], ['.hourly-detail #modalhireme-fixed-multifield-currency\n            option:selected']),
    _templateObject3 = _taggedTemplateLiteral(['Unahitaji kuthibitisha barua pepe yako ili kuajiri mfanyakazi mwingine huru. Tumekutumia barua pepe nyingine ya uthibitishaji. Tafadhali thibitisha barua pepe yako na ujaribu tena.'], ['Unahitaji kuthibitisha barua pepe yako ili kuajiri mfanyakazi mwingine huru. Tumekutumia barua pepe nyingine ya uthibitishaji. Tafadhali thibitisha barua pepe yako na ujaribu tena.']),
    _templateObject4 = _taggedTemplateLiteral(['Uundaji wa Hatua Muhimu umeshindikana, tafadhali jaribu tena. Tafadhali wasiliana na usaidizi kwa support@freelancer.com ikiwa hitilafu hii itaendelea.'], ['Uundaji wa Hatua Muhimu umeshindikana, tafadhali jaribu tena. Tafadhali wasiliana na usaidizi kwa support@freelancer.com ikiwa hitilafu hii itaendelea.']);

/**
                                                          * Warning: This module is used on ALL bootstrap pages across the site.
                                                          * Please be considerate when adding selectors, and use the
                                                          * quickhireFormContainerDom variable, private to this module, which refers to
                                                          * the container element for this modal to find the elements you are looking
                                                          * for. Otherwise this module may misbehave on other pages.
                                                          */

// The module must have a container with class 'quick-hire-form-container'
var budgetsCache = [];
var durationsCache = [];
var feeNotes = false;
var quickHireReturnData = {};
var thisUser = getUserIdfromCookie();
var quickhireFormContainerDom = {};
var selectedCurrencyDom = false;
var projectTypeDom = false;
// Entrypoint to be sent with TTREF events.
var entryPoint = 'directoryInline4';
var abTests = {};
var abTestSkipMilestone = false;
var isOnMilestoneCreation = false;
var milestoneCreationCancelRedirectUrl = null;
var hireMeModal = void 0;
var previousCurrency = void 0;
var freelancerUserId = void 0;
var hireMeLoadCallback = void 0;
var isDeloitteUser = false;
var isEscrowComRequired = false;

var ErrorCode = {
  EMAIL_VERIFICATION_REQUIRED: 20153,
  NEGATIVE_BALANCE_SUSPENSION: 20003,
  UNVERIFIED_PAYMENT_RESPONSE: 20001 };

var selectors = {
  draft: {
    budget: '[data-draft="budget"]',
    commitment: '[data-draft="commitment"]',
    currency: '[data-draft="currency"]',
    period: '[data-draft="period"]',
    pmb: '[data-draft="pmb"]',
    projectType: '[data-draft="project_type"]' } };

var HireMeDraft$1 = hireMeDraft();

function entryPointToQTS(original) {
  // Some of our ttref entryPoint values have a different QTS mapping. Arg!
  return original === 'directoryInline4' ? 'Directory' : original;
}

var hiremeEvents = {
  /* Tracking events called on form open, successful hire, milestone
                        * award/success
                        * Please use these instead of hacking additional events inline... :(
                        */
  success: function success(data) {
    _ttref.push(['_trackEvent', 'ProjectHireMe', 'Award', 'Success', 'project_id', data.project_id]);

    _lt.push({
      event: 'HireMe Posted' });
  },
  quickHireReturnDataReady: function quickHireReturnDataReady() {
    _lt.push(['user_action', {
      section: entryPointToQTS(entryPoint),
      subsection: 'MilestoneCreate_InitialHireMe',
      label: 'form_open',
      action: 'click',
      project_id: quickHireReturnData.project_id }]);
  },
  milestoneClick: function milestoneClick() {
    _ttref.push(['_trackEventNoCookie', 'HireMe', 'Initial_Milestone', entryPoint, 'click']);

    _lt.push(['user_action', {
      section: entryPointToQTS(entryPoint),
      subsection: 'MilestoneCreate_InitialHireMe',
      label: 'form_submit',
      action: 'click',
      project_id: quickHireReturnData.project_id }]);
  },
  milestoneSuccess: function milestoneSuccess() {}
};

function findErrorEl() {
  var errorEl = quickhireFormContainerDom.find('#quickhire-modal-milestone-generic-error, ' + '#quickhire-modal-generic-error, ' + '#milestone-error');

  return errorEl;
}

function findWarningEl() {
  return quickhireFormContainerDom.find('.quickhire-modal-generic-warning');
}

function displayError(message, code, sellerId) {
  var errorEl = findErrorEl();
  var errorTemplate = _.template(errorMessageTemplate)({
    ErrorCode: ErrorCode,
    T_: translate,
    code: code,
    message: message,
    userId: getUserIdfromCookie(),
    sellerId: sellerId });

  errorEl.html(errorTemplate);
  errorEl.show();
}

function displayWarning(message) {
  var warningEl = findWarningEl();
  warningEl.text(message);
  warningEl.show();
}

function hideError() {
  var errorEl = findErrorEl();
  errorEl.hide();
}

function convertToExchangeRate(amount, prevRate, curRate) {
  /*
                                                            * Exchange rates are all based on USD so convert the previous currency
                                                            * first to USD before changing to user's selected currency
                                                            */
  var convertedAmount = Math.round(amount * prevRate / curRate).toFixed(0);
  var roundingFactor = 1;

  if (convertedAmount > 10000) {
    roundingFactor = 1000;
  } else if (convertedAmount > 1000) {
    roundingFactor = 100;
  } else if (convertedAmount > 100) {
    roundingFactor = 10;
  }

  convertedAmount = Math.round(convertedAmount / roundingFactor) * roundingFactor;

  return convertedAmount;
}

function applyExchangeRate(selectedOption) {
  if (previousCurrency === selectedOption.val()) {
    return;
  }

  // Automatically convert the budget amount based on the selected currency
  var budgetAmountDom = quickhireFormContainerDom.find('.budget-amount');
  var previousValueDom = quickhireFormContainerDom.find(oneLine(_templateObject$2, previousCurrency));

  var prevRate = previousValueDom.attr('exchange-rate');
  var curRate = selectedOption.attr('exchange-rate');
  var budget = budgetAmountDom.val();
  var convertedBudget = convertToExchangeRate(budget, prevRate, curRate);
  budgetAmountDom.val(convertedBudget);
  previousCurrency = selectedOption.val();

  /*
                                            * Update the default exchange rate for hourly/fixed price if
                                            * budget amount field value was not yet modified
                                            */
  var hourlyValue = budgetAmountDom.attr('hourly-value');
  var fixedValue = budgetAmountDom.attr('fixed-value');
  if (hourlyValue !== fixedValue) {
    var convertedFixedValue = convertToExchangeRate(fixedValue, prevRate, curRate);

    var convertedHourlyValue = convertToExchangeRate(hourlyValue, prevRate, curRate);

    budgetAmountDom.attr('fixed-value', convertedFixedValue);
    budgetAmountDom.attr('hourly-value', convertedHourlyValue);
  }
}

// if the currency has higher value than USD set the minimum
// hourly rate equal to 1 otherwise set the minimum hourly rate
// to 1 USD equivalent of the selected currency. (exchange rate is <currency>/USD)
function computeMinimumHourlyBudget(exchangeRate) {
  return exchangeRate >= 1 ? 1 : Math.floor(1 / exchangeRate);
}

function changeMinimumBudget(params) {
  if (selectedCurrencyDom === false) {
    selectedCurrencyDom = quickhireFormContainerDom.find('#modalhireme-fixed-multifield-currency option:selected');
  }
  applyExchangeRate(selectedCurrencyDom);

  var projectTypeDetailDom = params.triggeringElement.closest('.project-type-detail');

  var sign = selectedCurrencyDom.attr('title');

  var minBudget = selectedCurrencyDom.attr('min-' + projectTypeDom.val() + '-budget');

  if (projectTypeDom.val() === 'hourly') {
    minBudget = computeMinimumHourlyBudget(selectedCurrencyDom.attr('exchange-rate'));

    selectedCurrencyDom.attr('min-hourly-budget', minBudget);
  }

  projectTypeDetailDom.find('.budget-currency-sign').html(sign);
  projectTypeDetailDom.find('.min-budget-currency-sign').html(sign);

  quickhireFormContainerDom.find('.min-budget-amount').html(minBudget);
  quickhireFormContainerDom.find('.budget-amount').attr('min', minBudget);
  quickhireFormContainerDom.find('.budget-amount').valid();
}

function formatBillingCode(code) {
  var billingCode = code.toUpperCase().replace(/[^A-Z\d]/g, '').split('');
  var separatorIndexes = [14, 12, 10, 8];
  var separator = '-';
  separatorIndexes.forEach(function (index) {
    if (billingCode.length > index) {
      billingCode.splice(index, 0, separator);
    }
  });
  billingCode = billingCode.join('').substr(0, 22);
  return billingCode;
}

function applyEvents() {
  quickhireFormContainerDom.on('click', '.btn-auth-type', function () {
    var that = jq(this);
    var form = quickhireFormContainerDom.find('.quick-hire-post-form');
    that.find('.user-type').attr('checked', 'checked');
    that.siblings('btn-auth-type').find('.user-type').attr('checked', false);
    if (that.hasClass('returning-user')) {
      form.find('.user-create').hide();
      form.find('.user-return').show();
    } else {
      form.find('.user-return').hide();
      form.find('.user-create').show();
    }
  });

  quickhireFormContainerDom.on('change', '.hoursOption', function () {
    var form = quickhireFormContainerDom.find('.quick-hire-post-form');
    var checkedOption = form.find('.hoursOption:checked');
    if (checkedOption.val() == 'notSure') {
      form.find('.project-workload').attr('disabled', true).val(1);
    } else {
      form.find('.project-workload').removeAttr('disabled');
    }
  });

  quickhireFormContainerDom.on('change', '#isClearanceRequired', function () {
    var checkBox = quickhireFormContainerDom.find('#isClearanceRequired');
    var input = quickhireFormContainerDom.find('#deloitteClearance');
    if (checkBox.is(':checked')) {
      input.prop('disabled', false);
    } else {
      input.prop('disabled', true);
    }
  });
  // deloitteClearance is dependent on checkbox, so have to manually remove errors
  quickhireFormContainerDom.on('keyup', '#deloitteClearance', function () {
    if (quickhireFormContainerDom.find('#deloitteClearance').val()) {
      clearValidationError(quickhireFormContainerDom.find('#deloitteClearance'));
    }
  });

  quickhireFormContainerDom.on('click', '.hours-option-text', function () {
    var forOption = jq(this).attr('for');
    jq(this).find('.hoursOption[value=' + forOption + ']').trigger('click');
  });

  quickhireFormContainerDom.on('click', '.cancel-quickhire', function () {
    quickhireFormContainerDom.find('.close').trigger('click');
  });

  quickhireFormContainerDom.on('click', '.site_plainterms', function () {
    window.open('/info/plainterms.html', '', 'width=1000, height=600, left=100,top=100,menu=no, ' + 'toolbar=no,scrollbars=yes,resizable=yes');

    return false;
  });

  quickhireFormContainerDom.on('click', '.site_privacy', function () {
    window.open('/page.php?p=info/privacy', '', 'width=1000, height=600, left=0,top=0,menu=no, ' + 'toolbar=no,scrollbars=yes,resizable=yes');

    return false;
  });

  projectTypeDom.on('change', function () {
    var formContainer = quickhireFormContainerDom;
    var freelancerId = quickhireFormContainerDom.find('.quick-hire-post-form').data('seller-id');

    if (projectTypeDom.val() === 'hourly') {
      formContainer.find('#min-budget-per-hour').show();
      formContainer.find('.fixed-detail').hide();
      formContainer.find('.hourly-detail').show();
      formContainer.find('#project_fix_fee_note').hide();
      formContainer.find('#project_hourly_fee_note').show();

      _t.push(['user_action', {
        section: 'HireMeModal',
        name: 'ToggleToHourly',
        label: 'Per Hour',
        reference: 'freelancer_id',
        reference_id: freelancerId }]);
    } else {
      formContainer.find('#min-budget-per-hour').hide();
      formContainer.find('.hourly-detail').hide();
      formContainer.find('.fixed-detail').show();
      formContainer.find('#project_fix_fee_note').show();
      formContainer.find('#project_hourly_fee_note').hide();

      _t.push(['user_action', {
        section: 'HireMeModal',
        name: 'ToggleToFixedPrice',
        label: 'Fixed Price',
        reference: 'freelancer_id',
        reference_id: freelancerId }]);
    }

    var budgetAmountDom = formContainer.find('.budget-amount');
    budgetAmountDom.val(budgetAmountDom.attr(projectTypeDom.val() + '-value'));
    budgetAmountDom.focusout();

    changeMinimumBudget({
      triggeringElement: jq(this) });
  });

  quickhireFormContainerDom.on('click', '.btn-quickhire', function () {
    var form = quickhireFormContainerDom.find('.quick-hire-post-form');
    var hasAuthErrors = false;

    if (quickhireFormContainerDom.find('#userTypeReturning').is(':checked') && !userAuthForm.userReturned()) {
      quickhireFormContainerDom.find('#post-proj-username, #post-proj-pwd').closest('.control-group').removeClass('success').addClass('error');
      quickhireFormContainerDom.find('#post-proj-pwd').siblings('.help-inline').html(translate('Tafadhali angalia maelezo yako ya kuingia.'));
      hasAuthErrors = true;
    }

    if (hasAuthErrors) {
      var errorElement = quickhireFormContainerDom.find('.control-group.error:first').offset().top;
      jq(document).scrollTop(errorElement - 250);
    }
    if (validateForm$1(form) && thisUser) {
      submitForm(form);
    }
  });

  quickhireFormContainerDom.on('click', '.btn-quickhire-create-milestone', function () {
    var milestoneForm = quickhireFormContainerDom.find('.quick-hire-milestone-form');

    if (validateMilestoneForm(milestoneForm)) {
      submitMilestoneForm(milestoneForm);
    }
  });

  quickhireFormContainerDom.on('click', '.btn-quickhire-no-milestone', function () {
    var formContainer = quickhireFormContainerDom;
    formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true);
    formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
  });

  quickhireFormContainerDom.on('change', '#modalhireme-fixed-multifield-currency', function () {
    selectedCurrencyDom = jq(this).find('option:selected');
    changeMinimumBudget({
      triggeringElement: jq(this) });
  });

  quickhireFormContainerDom.on('change', '.budget-amount', function () {
    jq(this).attr('fixed-value', jq(this).val());
    jq(this).attr('hourly-value', jq(this).val());
  });

  quickhireFormContainerDom.on('keyup', '#deloitteBillingCode', function () {
    var that = jq(this);
    var code = formatBillingCode(that.val());
    that.val(code);
  });

  quickhireFormContainerDom.on('paste', '#deloitteBillingCode', function () {
    var that = jq(this);
    var code = formatBillingCode(that.val());
    that.val(code);
  });

  if (isDeloitteUser) {
    quickhireFormContainerDom.on('change', '#deloitteOffering', function () {
      var that = jq(this);
      var offering = that.find(':selected').parent().attr('label');
      quickhireFormContainerDom.find('[data-offering-category]').text(offering || '');
    });

    jq.validator.addMethod('checkEndDate', function (value, element) {
      var that = jq(element);
      var inputVal = that.val();
      if (inputVal && quickhireFormContainerDom.find('#startDate').val() && inputVal > quickhireFormContainerDom.find('#startDate').val()) {
        return true;
      }
      return false;
    }, translate('Tarehe ya mwisho inapaswa kuwa kubwa kuliko tarehe ya kuanza.'));

    jq.validator.addMethod('checkStartDate', function () {
      var form = quickhireFormContainerDom.find('.quick-hire-post-form');
      form.validate().element('#endDate');
      return true;
    }, translate('Tarehe ya mwisho inapaswa kuwa kubwa kuliko tarehe ya kuanza.'));

    jq.validator.addMethod('checkDeloitteBillingCode', function (value, element) {
      var that = jq(element);
      var inputVal = that.val();
      var billingCodeRegex = new RegExp(/^[A-Z]{3}[\d]{5}-[A-Z\d]{2}-[A-Z\d]{2}-[A-Z\d]{2}-[\d]{4}$/, 'i');

      return billingCodeRegex.test(inputVal);
    }, translate('Please enter a valid billing code.'));

    jq.validator.addMethod('checkGAABillingCode', function (value, element) {
      var that = jq(element);
      var inputVal = that.val();
      var billingCodeRegex = new RegExp(/^(?!GAA).*$/, 'i');
      return billingCodeRegex.test(inputVal);
    }, translate('You may not use a WBS code beginning with GAA to post a gig.'));

    jq.validator.addMethod('checkClearance', function (value, element) {
      var that = jq(element);
      var checked = that[0].checked;
      // deloitteClearance is dependent on checkbox, so have to manually trigger error msgs
      if (checked) {
        if (!quickhireFormContainerDom.find('#deloitteClearance').val()) {
          addValidationError(quickhireFormContainerDom.find('#deloitteClearance'));

          return false;
        }
      }
      clearValidationError(quickhireFormContainerDom.find('#deloitteClearance'));

      return true;
    }, translate('Tafadhali toa kibali.'));
  } else {
    jq.validator.addMethod('checkCraigslistViolation', function (value, element) {
      var craigslistTerms = ['craigslist', /(^|\W)cl($|\W)/, 'clist'];
      var violationTerms = ['ghost', 'ghosting', 'flag', 'flagging', 'block', 'blocking', 'pva', 'pvas', 'phone verified accounts', 'auto reply', 'auto respond', 'post', 'poster', 'posting', 'autopost', 'autoposter', 'autoposting', 'anti-flagging', 'captcha', 'captchas'];

      var craigslistCheckResult = false;
      for (var i = craigslistTerms.length - 1; i >= 0; i--) {
        if (jq(element).val().toLowerCase().match(craigslistTerms[i])) {
          craigslistCheckResult = true;
        }
      }
      var violationCheckResult = false;
      for (var j = violationTerms.length - 1; j >= 0; j--) {
        if (jq(element).val().toLowerCase().match(violationTerms[j])) {
          violationCheckResult = true;
        }
      }
      if (craigslistCheckResult && violationCheckResult) {
        jq(this).find('#warning_craigslist_id').show();
        return true;
      }
      quickhireFormContainerDom.find('#warning_craigslist_id').hide();
      return true;
    }, translate('Tafadhali hakikisha haukiuki Sheria za Utumiaji za Craiglist.'));

    jq.validator.addMethod('checkCopyRightViolation', function (value, element) {
      var copyRightViolationTerms = ['clone', 'exact copy'];

      for (var i = copyRightViolationTerms.length - 1; i >= 0; i--) {
        if (jq(element).val().toLowerCase().match(copyRightViolationTerms[i])) {
          jq(this).find('#warning_copyright_id').show();
          return true;
        }
      }
      quickhireFormContainerDom.find('#warning_copyright_id').hide();
      return true;
    }, translate('Tafadhali hakikisha haukiuki Sheria za Utumiaji za Craiglist.'));

    jq.validator.addMethod('checkFixedPeriod', function (value, element) {
      var that = jq(element);

      if (projectTypeDom.val() === 'fixed') {
        var inputAmount = parseInt(that.val(), 10);
        if (Number.isNaN(inputAmount) || inputAmount <= 0) {
          return false;
        }
      }
      return true;
    }, translate('Tafadhali weka muda sahihi.'));

    jq.validator.addMethod('checkHourlyWorkload', function (value, element) {
      var that = jq(element);

      if (projectTypeDom.val() === 'hourly') {
        var inputAmount = parseInt(that.val(), 10);
        if (Number.isNaN(inputAmount) || inputAmount <= 0) {
          return false;
        }
      }
      return true;
    }, translate('Tafadhali weka kiwango sahihi cha kazi'));

    jq.validator.addMethod('checkBudget', function (value, element) {
      var form = quickhireFormContainerDom;
      var that = jq(element);
      var inputAmount = parseInt(that.val(), 10);
      var minBudgetAmount = 0;
      var optionSelected = void 0;

      if (projectTypeDom.val() === 'fixed') {
        optionSelected = form.find('.fixed-detail ' + '#modalhireme-fixed-multifield-currency option:selected');

        minBudgetAmount = parseInt(optionSelected.attr('min-fixed-budget'), 10);
      } else if (projectTypeDom.val() === 'hourly') {
        optionSelected = form.find(oneLine(_templateObject2));

        minBudgetAmount = parseInt(optionSelected.attr('min-hourly-budget'), 10);
      }

      if (Number.isNaN(inputAmount) || inputAmount < minBudgetAmount) {
        return false;
      }

      return true;
    }, translate('Tafadhali weka bajeti iliyo sahihi.'));
  }
}

function addValidationError(element) {
  element.closest('.control-group').addClass('error is-invalid').removeClass('is-valid');
}

function clearValidationError(element) {
  element.closest('.control-group').removeClass('error is-invalid').addClass('is-valid');
}

function requirePaymentVerification() {
  hireMeModal.hide();
  return jq.ajax({
    url: '/ajax/hireme/getEncodedUserProfileUrl.php',
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    type: 'GET',
    data: { user_id: freelancerUserId },
    success: function success(response) {
      if (response.status == 'success') {
        var params = jq.param({
          quickVerify: 'true',
          skipTrial: 'true',
          next: response.url });

        showPaymentVerificationModal('/verify?' + params);
      }
    }
  });
}

var loadDraft = function loadDraft(employerId, freelancerId) {
  var data = HireMeDraft$1.get(employerId, freelancerId);

  if (!data) {
    return;
  }

  if (data.commitment) {
    quickhireFormContainerDom.find(selectors.draft.commitment).val(data.commitment);
  }

  if (data.period) {
    quickhireFormContainerDom.find(selectors.draft.period).val(data.period);
  }

  quickhireFormContainerDom.find(selectors.draft.pmb).val(data.pmb);
  quickhireFormContainerDom.find(selectors.draft.projectType).val(data.projectType).trigger('change');
  quickhireFormContainerDom.find(selectors.draft.currency).val(data.currency).trigger('change');
  quickhireFormContainerDom.find(selectors.draft.budget).val(data.budget).trigger('change');
};

var saveDraft = function saveDraft(employerId, freelancerId, data) {
  var dataToSave = {
    budget: data.budget,
    commitment: data.commitment,
    currency: data.currency,
    period: data.period,
    pmb: data.pmb,
    projectType: data.type };

  HireMeDraft$1.save(employerId, freelancerId, dataToSave);
};

function submitForm(form) {
  var data = {};
  var skills = [];
  var selectedSkills = form.find('.selected_skill');
  var formContainer = quickhireFormContainerDom;
  for (var i = 0; i < selectedSkills.length; i++) {
    skills.push(jq(selectedSkills[i]).attr('value'));
  }
  data.skills = skills;
  data.csrf_token = getCSRFToken();
  data.type = projectTypeDom.val();

  if (data.type == 'fixed') {
    var fixedDetail = form.find('.fixed-detail');
    data.period = fixedDetail.find('.project-period').val();
    data.currency = fixedDetail.find('#modalhireme-fixed-multifield-currency').val();
    data.budget = fixedDetail.find('.budget-amount').val();
  } else if (data.type == 'hourly') {
    var hourlyDetail = form.find('.hourly-detail');
    data.commitment_interval = 'week';
    data.duration = hourlyDetail.find('.project-duration').val();
    data.commitment = hourlyDetail.find('.project-workload').val();
    data.budget = hourlyDetail.find('.budget-amount').val();
    data.currency = hourlyDetail.find('#modalhireme-fixed-multifield-currency').val();
  } else if (isDeloitteUser) {
    var startDate = form.find('#startDate').val();
    startDate = Math.round(new Date(startDate).getTime() / 1000);
    var endDate = form.find('#endDate').val();
    endDate = Math.round(new Date(endDate).getTime() / 1000);
    data.timeframe = {
      start_date: startDate,
      end_date: endDate };

    data.deloitte_details = {
      billing_code: form.find('#deloitteBillingCode').val(),
      industry_offering: {
        industry: form.find('#deloitteIndustry').val(),
        offering: form.find('#deloitteOffering').val(),
        practice: form.find('#deloittePractice').val(),
        project_type: form.find('#deloitteProjectType').val() },

      itar: form.find('#deloitteItar').is(':checked') ? 'Yes' : '',
      clearance: form.find('#deloitteClearance').val() };

    data.commitment_interval = 'week';
    data.commitment = parseInt(form.find('#deloitteBillableHours').val(), 10);
    data.duration = 6; // hard coded in html for non deloitte users
    data.currency = 40; // TKN currency
    data.budget = 1;
    data.type = 'hourly';
  } else {
    return false;
  }

  data.pmb = form.find('#pmb').val();
  data.autoNameAndDescription = true;
  data.sellerId = form.data('seller-id');
  data.sellerUsername = form.data('seller-username');
  data.sourceType = form.data('source-type');
  data.sourceId = form.data('source-id');

  var authform = quickhireFormContainerDom.find('#nonAuthForm');
  if (!thisUser && authform.find('#userTypeNew').is(':checked')) {
    data.username = authform.find('#new-username').val();
    data.email = authform.find('#new-email').val();
    data.passwd = authform.find('#passwd').val();
    data.passwd1 = data.passwd;
    data.email_notify = true;
  }

  jq.ajax({
    url: '/buyers/onquickhire.php',
    type: 'post',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      formContainer.find('.loading-img').show();
      formContainer.find('.btn-quickhire').attr('disabled', true).hide();
      formContainer.find('.cancel-quickhire').attr('disabled', true);
      hideError();
    },
    success: function success(response) {
      hiremeEvents.success(response);
      HireMeDraft$1.remove(thisUser, data.sellerId);

      if (response.status == 'success' && !response.ABTestAutomaticPayment) {
        if (response.result && response.result.deloitte_details) {
          window.location.href = '/projects/' + response.result.seo_url;
        } else if (isEscrowComRequired) {
          window.location.href = response.url;
        } else {
          isOnMilestoneCreation = true;
          var popoverPlacement = 'right';
          upsellUpgrades(response);
          quickhireFormContainerDom.removeClass('quick-hire-form-container');
          popoverPlacement = 'bottom';

          quickHireReturnData = response;
          hiremeEvents.quickHireReturnDataReady();

          milestoneCreationCancelRedirectUrl = quickHireReturnData.url;

          var budget = data.budget;
          if (data.type === 'fixed') {
            budget *= 0.5;
          }

          var quickHireMilestoneFormHTML = _.template(quickHireMilestoneFormTemplate)({
            username: data.sellerUsername,
            userID: data.sellerId,
            quickHireReturnData: quickHireReturnData,
            budget: budget,
            type: data.type,
            commitment: data.type == 'hourly' ? data.commitment : false,
            abTestSkipMilestone: abTestSkipMilestone,
            T_: translate,
            cdn_url: cdn_url,
            uiIcon: uiIcon });

          quickhireFormContainerDom.html(quickHireMilestoneFormHTML);
          quickhireFormContainerDom.find('#milestones-popover').popover({
            placement: popoverPlacement,
            trigger: 'hover',
            animation: true,
            template: '<div class="popover"><div class="arrow"></div>' + '<div class="popover-inner">' + '<div class="popover-content"><p></p></div></div></div>' });

          initMilestoneValidator(quickhireFormContainerDom.find('.quick-hire-milestone-form'));

          thisUser = getUserIdfromCookie();

          quickhireFormContainerDom.find('#milestone-not-now').click(function () {
            hireMeModal.hide();
          });

          // Show div to display info about not being able
          // to send the private message
          if (response.pmNotSentMessage) {
            displayWarning(response.pmNotSentMessage);
          }

          quickhireFormContainerDom.find('.btn-quickhire-no-milestone').on('click', function () {
            // Because the href in the button on the template
            // does not redirect in some older browsers
            // (looking at you, IE8)
            window.location.href = quickHireReturnData.url;
          });
        }

        return;
      }

      if (response.status === 'failed') {
        saveDraft(thisUser, data.sellerId, data);

        if (response.code === ErrorCode.UNVERIFIED_PAYMENT_RESPONSE) {
          return requirePaymentVerification();
        }
      }

      if (response.url) {
        window.location.href = response.url;
      } else {
        displayError(response.reason, response.code, data.sellerId);
      }
    },
    error: function error(response) {
      saveDraft(thisUser, freelancerUserId, data);

      if (response.responseJSON.error.code === 'EMAIL_VERIFICATION_REQUIRED') {
        displayError(translate(_templateObject3), ErrorCode.EMAIL_VERIFICATION_REQUIRED);
      } else {
        displayError(translate('Kasoro ya Mtandao'));
      }
    },
    complete: function complete() {
      formContainer.find('.loading-img').hide();
      formContainer.find('.btn-quickhire').removeAttr('disabled').show();
      formContainer.find('.cancel-quickhire').removeAttr('disabled');
    }
  });
}

function getTotal() {
  var quickhire = quickhireFormContainerDom;
  var total = awardUpgrades.getUpgradeTotal();
  if (parseFloat(quickhire.find('.milestone-amount').val())) {
    total += parseFloat(quickhire.find('.milestone-amount').val());
  }
  return total.toFixed(2);
}

function upsellUpgrades(data) {
  var quickhire = quickhireFormContainerDom;
  var that = this;
  var updateTotal = function updateTotal() {
    quickhire.find('.total-amount').html(getTotal());
  };
  var initPaymentSource = function initPaymentSource(data) {
    var paymentsSourceDetails = {
      currencyDetails: {
        id: data.currency_id,
        sign: data.currency_sign,
        code: data.currency_code } };

    paymentsSourceDetails.amount = getTotal();
    paymentSource.init(paymentsSourceDetails, quickhire.find('#payment-sources-container'));
  };

  var upgradesPrepared = function upgradesPrepared() {
    awardUpgrades.init();
    initPaymentSource(data);
    updateTotal();
    quickhire.find('.upgrade-checkbox').on('change', updateTotal);
    quickhire.find('.milestone-amount').on('keyup', updateTotal);
  };

  if (typeof data.abTestPrehire !== 'undefined' && data.abTestPrehire) {
    awardUpgrades.prepareUpgradeForPreHireChat(data.currency_id).then(function () {
      upgradesPrepared();
    });
  } else {
    awardUpgrades.prepareUpgradeABTest(data.project_id, true).then(function () {
      upgradesPrepared();
      quickhire.off('click', '.btn-quickhire-create-milestone').on('click', '.btn-quickhire-create-milestone', function () {
        var milestoneForm = quickhire.find('.quick-hire-milestone-form');
        if (validateMilestoneForm(milestoneForm)) {
          awardUpgrades.upgradeAndCreateMilestone(data, milestoneForm, submitMilestoneForm, that);
        }
      });
    });
  }
}

function submitMilestoneForm(milestoneForm) {
  var isPrehireProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var formContainer = quickhireFormContainerDom;
  formContainer.find('.loading-img').show();
  hiremeEvents.milestoneClick();
  formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true).hide();
  formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
  hideError();
  jq.ajax({
    url: '/ajax/give-and-get/getDelayedPaymentVerifyVars.php',
    type: 'get',
    data: {},
    success: function success(response) {
      if (!response.isChildPaymentVerified && response.inExperiment && response.isTest) {
        redirectToPv(milestoneForm);
      } else {
        submitMilestone(milestoneForm, isPrehireProject);
      }
    },
    error: function error() {
      submitMilestone(milestoneForm, isPrehireProject);
    }
  });
}

function redirectToPv(milestoneForm) {
  var data = {
    csrf_token: getCSRFToken(),
    seller_name: quickHireReturnData.seller_username,
    seller_id: quickHireReturnData.seller_id,
    currency_id: quickHireReturnData.currency_id,
    project_id: quickHireReturnData.project_id,
    milestone_amount: milestoneForm.find('.milestone-amount').val(),
    description: milestoneForm.find('.milestone-descr').val() };

  jq.ajax({
    url: '/ajax/give-and-get/getAutoCreateMilestoneToken.php',
    type: 'get',
    data: data,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    dataType: 'json',
    beforeSend: function beforeSend() {},
    success: function success(response) {
      window.location.href = '/verify?next=/projects/' + encodeURIComponent(quickHireReturnData.project_id) + '&data_token=' + response.data_token;
    },
    error: function error() {},
    complete: function complete() {}
  });
}

function submitMilestone(milestoneForm) {
  var isPrehireProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // track user confirm to create milestone
  var data = {};
  var formContainer = quickhireFormContainerDom;
  data.csrf_token = getCSRFToken();
  data.username = quickHireReturnData.seller_username;
  data.amount = milestoneForm.find('.milestone-amount').val();
  data.project = quickHireReturnData.project_id;
  data.reason = 'partly_payment';
  data.other_reason = milestoneForm.find('.milestone-descr').val();
  data.currency = quickHireReturnData.currency_id;
  data.bidId = quickHireReturnData.initial_bid.id;
  data.bidderId = quickHireReturnData.seller_id;

  // m is useMaster
  data.m = true;

  jq.ajax({
    url: '/ajax/payment/onnewescrow.php',
    type: 'post',
    data: data,
    headers: { 'X-XSRF-TOKEN': getCSRFToken() },
    dataType: 'json',
    beforeSend: function beforeSend() {
      formContainer.find('.loading-img').show();
      formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true).hide();
      formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
      hideError();
    },
    success: function success(response) {
      if (response.status == 'success') {
        if (!isPrehireProject) {
          quickHireReturnData.url += '&ttref=HireMe_' + entryPoint + '&hireme_initial_milestone_tracking=immediate';
          window.location.href = quickHireReturnData.url;
        } else {
          formContainer.find('.loading-img').hide();
          hireMeModal.hide();
        }
      } else if (response.needDeposit) {
        var r = createMilestoneCartItem(data);
        r.then(function (response) {
          if (response.status === 'success') {
            var uri = '/deposit/?cartId=' + response.result;

            window.location = uri;
          } else {
            displayMilestoneCartError();
          }
        }).fail(function () {
          displayMilestoneCartError();
        });
      } else {
        displayError(response.msg);
        formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
        formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
        formContainer.find('.loading-img').hide();
      }
    },
    error: function error() {
      displayError(translate('Kasoro ya Mtandao'));
      formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
      formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
      formContainer.find('.loading-img').hide();
    },
    complete: function complete() {
      formContainer.find('.loading-img').hide();
    }
  });
}

function displayMilestoneCartError() {
  var formContainer = quickhireFormContainerDom;

  displayError(translate(_templateObject4));

  formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
  formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
  formContainer.find('.loading-img').hide();
}

/**
   * 1. Create milestone draft
   * 2. Create cart
   * 3. Create cart item
   */
function createMilestoneCartItem(data) {
  var cartId = null;
  var milestoneDraftId = null;

  var amount = Number(data.amount);
  var projectId = Number(data.project);
  var desc = data.other_reason;
  var currencyId = Number(data.currency);
  var bidId = Number(data.bidId);
  var bidderId = Number(data.bidderId);
  return jq.ajax({
    url: '/api/projects/0.1/milestone_drafts/',
    type: 'POST',
    dataType: 'json',
    data: JSON.stringify({
      amount: amount,
      bidder_id: bidderId,
      bid_id: bidId,
      currency_id: currencyId,
      description: desc,
      project_id: projectId }),

    contentType: 'application/json',
    headers: getAuthHeader() }).then(function (response) {
    if (response.status !== 'success') {
      return response;
    }
    milestoneDraftId = response.result.id;

    // Create cart
    var returnAction = {
      destination: 'project_view_page',
      payload: projectId.toString() };

    return jq.ajax({
      url: '/api/payments/0.1/carts/',
      type: 'POST',
      data: JSON.stringify({
        description: 'Hire Me Initial Milestone',
        return_action: returnAction }),

      contentType: 'application/json',
      headers: getAuthHeader() });
  }).then(function (response) {
    if (response.status !== 'success') {
      return response;
    }
    cartId = response.result.id;

    return jq.ajax({
      url: '/api/payments/0.1/carts/' + cartId + '/cart_items/',
      type: 'POST',
      data: JSON.stringify({
        context_type: 'milestone',
        context_id: milestoneDraftId.toString(),
        description: desc,
        currency: currencyId,
        amount: amount,
        cart_id: cartId,
        context_sub_type: -1 }),

      contentType: 'application/json',
      headers: getAuthHeader() });
  }).then(function (res) {
    if (res.status === 'success') {
      return { status: 'success', result: cartId };
    }
    return res;
  });
}

function createPrehireProject(params, milestoneForm) {
  var that = jq(this);
  var formContainer = quickhireFormContainerDom;
  var initialMilestoneAmount = parseFloat(jq('.milestone-amount').val());
  var data = {
    currency: params.employer.primary_currency.id,
    sellerUsername: params.freelancer.username,
    sellerId: params.freelancer.id,
    type: 'fixed',
    period: 999,
    budget: initialMilestoneAmount,
    isPrehireProject: true,
    csrf_token: getCSRFToken(),
    autoNameAndDescription: true,
    prehireTotalCharge: getTotal(),
    autoSendPMB: params.autoSendPMB };

  data.drive_files = formContainer.find('[data-upload-field="drive_files"]').val();

  jq.ajax({
    url: '/buyers/onquickhire.php',
    type: 'post',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      formContainer.find('.loading-img').show();
      formContainer.find('.btn-quickhire-create-milestone').attr('disabled', true).hide();
      formContainer.find('.btn-quickhire-no-milestone').attr('disabled', true);
      hideError();
    },
    success: function success(response) {
      if (response.status == 'success') {
        params.deferred.resolve(response.project_id);
        milestoneForm.find('#prehire-created').show();

        var upgradeData = {
          project_id: response.project_id,
          currency_id: response.currency_id,
          seller_id: response.seller_id,
          seller_username: response.seller_username,
          abTestPrehire: true };

        quickHireReturnData = response;

        awardUpgrades.upgradeAndCreateMilestone(upgradeData, milestoneForm, submitMilestoneForm, that, true);
      } else {
        params.deferred.reject('Failed to create project');
        if (response.reason) {
          displayError(response.reason, response.code);
        }
        if (response.url) {
          window.location.href = response.url;
        }
      }
    },
    error: function error() {
      params.deferred.reject('Failed to create project');
      displayError(translate('Kasoro ya Mtandao'));
    },
    complete: function complete() {
      formContainer.find('.loading-img').hide();
      formContainer.find('.btn-quickhire-no-milestone').removeAttr('disabled');
      formContainer.find('.btn-quickhire-create-milestone').removeAttr('disabled').show();
    }
  });
}

function validateForm$1(form) {
  var detailErrors = false;

  if (projectTypeDom.val() === 'hourly') {
    detailErrors = form.find('.fixed-detail .error');
  } else if (projectTypeDom.val() === 'fixed') {
    detailErrors = form.find('.hourly-detail .error');
  }

  if (detailErrors !== false) {
    detailErrors.removeClass('error');
    detailErrors.find('.help-block').html('');
  }
  return form.valid();
}

function validateMilestoneForm(milestoneForm) {
  return milestoneForm.valid();
}

function initMilestoneValidator(milestoneForm) {
  jq.validator.addMethod('checkMilestoneAmount', function (value, element) {
    var that = jq(element);
    var inputAmount = parseFloat(that.val());
    if (Number.isNaN(inputAmount) || inputAmount <= 0) {
      return false;
    }
    return true;
  }, translate('Tafadhali weka kiasi kamili'));

  milestoneForm.validate({
    errorElement: 'span',
    onsubmit: false,
    errorPlacement: function errorPlacement(error, element) {
      error.appendTo(element.closest('.control-group').find('.help-block'));
    },
    onfocusout: function onfocusout(element) {
      if (jq(element).val()) {
        jq(element).valid();
      } else {
        return false;
      }
    },
    highlight: function highlight(label) {
      jq(label).closest('.control-group').addClass('error is-invalid').removeClass('is-valid');
    },
    success: function success(label) {
      jq(label).closest('.control-group').removeClass('error is-invalid').addClass('is-valid');
    },

    rules: {
      milestoneAmount: {
        checkMilestoneAmount: true,
        min: 0.01,
        required: true },

      milestoneDescr: {
        minlength: 1,
        maxlength: 40,
        required: true } } });
}

function initValidator(form) {
  var rules = {};
  if (isDeloitteUser) {
    rules = {
      startDate: {
        required: true,
        checkStartDate: true },

      endDate: {
        required: true,
        checkEndDate: true },

      deloitteBillingCode: {
        checkGAABillingCode: true,
        checkDeloitteBillingCode: true },

      deloitteBillableHours: {
        required: true,
        min: 1,
        max: 1000 },

      deloitteUserAgreement: {
        required: true },

      deloitteIndustry: {
        required: true },

      deloitteOffering: {
        required: true },

      deloittePractice: {
        required: true },

      deloitteProjectType: {
        required: true },

      isClearanceRequired: {
        checkClearance: true } };
  } else {
    rules = {
      pmb: {
        minlength: 10,
        maxlength: 4000,
        checkCraigslistViolation: true,
        required: true },

      fixedBudget: {
        checkBudget: true },

      fixedPeriod: {
        checkFixedPeriod: true },

      hourlyWorkload: {
        checkHourlyWorkload: true },

      hourlyRate: {
        checkBudget: true },

      budget: {
        checkBudget: true } };
  }
  form.validate({
    errorElement: 'span',
    onsubmit: false,
    errorPlacement: function errorPlacement(error, element) {
      element.closest('.control-group').find('.help-block, .help-inline').eq(0).html(error);
    },
    onfocusout: function onfocusout(element) {
      if (jq(element).val()) {
        jq(element).valid();
      } else {
        return false;
      }
    },
    highlight: function highlight(label) {
      jq(label).closest('.control-group').addClass('error');
    },
    success: function success(label) {
      jq(label).closest('.control-group').removeClass('error');
    },

    rules: rules,
    messages: {} });
}

function initFileUpload(params) {
  // First param was never used in this module. Add in support if you need
  // it.
  fileupload.init(undefined, params, true, true);
}

function initTooltips(form) {
  form.find('#autoOpenToBidding-tip').popover({
    placement: 'top',
    template: '<div class="popover"><div class="arrow"></div>' + '<div class="popover-inner" style="width:400px">' + '<h3 class="popover-title"></h3><div class="popover-content"><p></p>' + '</div></div></div>' });

  form.find('#project-type-tip').popover({
    placement: 'top',
    content: '' + translate('<b>Bei Isiyobadilika</b>: Inafaa ukiwa na mradi ulio wazi na unaoeleweka kinaganaga.') + (translate('Ada za mradi zinatozwa wakati mfanyakazi huru anakubali mradi.') + '<br><br>') + ('' + translate('<b>Miradi ya Saa</b>: Inapendekezwa ukitaka kumuajiri mfanyakazi huru kwa kazi inayoendelea.')) + ('' + translate('Maelezo ya mradi yapaswa yaeleweke. Ada ya mradi inatozwa kila mfanyakazi huru anapolipwa.')),
    trigger: 'hover',
    html: true });

  form.find('.quick-hire-post-form-tip').each(function () {
    var that = jq(this);
    that.popover({
      content: that.data('content'),
      title: that.data('title'),
      placement: 'top',
      trigger: 'hover',
      html: true });
  });
}

var showHireMeModal = function showHireMeModal(hireMeModal, hireMeParams, fileUploadParams) {
  hireMeModal.show();

  var formContainer = jq('#quick-hire-form');
  projectTypeDom = formContainer.find('#project-type');
  applyEvents();
  var form = formContainer.find('.quick-hire-post-form');
  initValidator(form);
  initTooltips(form, hireMeParams);
  initFileUpload(fileUploadParams);
  showFixedBudgetSuggestion(hireMeParams.userID, hireMeParams.username, form);

  var today = new Date().toISOString().split('T')[0];
  form.find('#startDate').attr('min', today);
  form.find('#endDate').attr('min', today);

  selectBudgetType(hireMeParams, projectTypeDom);

  if (thisUser && hireMeParams.currencyId) {
    quickhireFormContainerDom.find('#modalhireme-fixed-multifield-currency').val(hireMeParams.currencyId).trigger('change');
  }

  loadDraft(thisUser, freelancerUserId);
};

var showHireMeWebappModal = function showHireMeWebappModal() {
  webappModals.open('HireMeWebappModalComponent', {
    inputs: {
      profileUserId: freelancerUserId },

    size: 'mid',
    edgeToEdge: true });
};

function initForm(hireMeParams, fileUploadParams, ttSource) {
  if (!document.getElementById('modal-hire-me')) {
    document.body.insertAdjacentHTML('beforeend', hiremeModalContainerTemplate);
  }

  freelancerUserId = hireMeParams.userID;

  if (typeof hireMeParams.abTests === 'object' && hireMeParams.abTests) {
    abTests = hireMeParams.abTests;
  }

  var initCallback = function initCallback() {
    if (typeof window.abTestHiremeMilestone !== 'undefined' && window.abTestHiremeMilestone) {
      abTestSkipMilestone = window.abTestHiremeMilestone;
    }

    if (ttSource) {
      entryPoint = ttSource;
    }

    // Sensible fallback values
    // Consider using
    // /ajax/getProjectSuggestedBudget.php?user_id=...
    hireMeParams = jq.extend({
      fixed_budget: 250,
      hourlyrate: 10,
      default_min: 10,
      daysDuration: 3 }, hireMeParams);

    feeNotes = feeNotes || (thisUser == hireMeParams.userID ? false : hireMeParams.projectFee);
    if (hireMeParams.enterpriseId && hireMeParams.enterpriseId == 1) {
      isDeloitteUser = true;
    } else {
      isDeloitteUser = false;
    }

    // T241300 Remove this code afterwards.
    var isArrowDomain = window.location.hostname === 'freelancer.arrow.com';

    var quickHireFormHTML = _.template(quickHireFormTemplate)({
      username: hireMeParams.username.trim(),
      userID: hireMeParams.userID,
      hourlyrate: hireMeParams.hourlyrate,
      is_online: hireMeParams.is_online,
      email: hireMeParams.email || '',
      budgets: budgetsCache,
      min_fixed_budget: hireMeParams.fixed_budget,
      default_min: hireMeParams.default_min,
      durations: durationsCache,
      days_duration: hireMeParams.daysDuration,
      autoProjectName: '',
      thisUser: thisUser,
      feeNotes: feeNotes,
      isNewUser: hireMeParams.isNewUser,
      project_title: hireMeParams.projectTitle || '',
      project_description: hireMeParams.projectDescription || '',
      show_hireme_promotion_copy: hireMeParams.showHireMePromotionCopy,
      sourceType: hireMeParams.sourceType || 'HiremeModal',
      sourceId: hireMeParams.sourceId,
      isDeloitteUser: isDeloitteUser,
      deloitteAdditionalFieldsData: {
        DeloitteProjectType: DeloitteProjectType,
        DeloittePractice: DeloittePractice,
        DeloitteIndustry: DeloitteIndustry,
        DeloitteOffering: DeloitteOffering,
        DeloitteOfferingPortfolio: DeloitteOfferingPortfolio },

      abTests: abTests,
      T_: translate,
      uiIcon: uiIcon,
      cdn_url: cdn_url,
      locale: {
        fileupload: {
          errors: {
            maxFileSize: translate('Ukubwa wa faili yako unazidi 20MBs.'),
            minFileSize: translate('Faili ni ndogo mno'),
            acceptFileTypes: translate('Aina ya faili hairuhusiwi'),
            maxNumberOfFiles: translate('Idadi ya juu ya faili imezidishwa'),
            uploadedBytes: translate('Vilivyopakiwa vinazidi ukubwa wa faili'),
            emptyResult: translate('Matokeo ya faili iliyopakiwa ni tupu') },

          error: translate('Kasoro'),
          start: translate('Anza'),
          cancel: translate('Batilisha'),
          destroy: translate('Futa') } },

      isEscrowComRequired: isEscrowComRequired,
      isArrowDomain: isArrowDomain });

    previousCurrency = jq(quickHireFormHTML).find('#modalhireme-fixed-multifield-currency option:selected').val();

    var quickHireFormHeaderHTML = _.template(quickHireFormTemplateHeader)({
      T_: translate,
      username: hireMeParams.username.trim(),
      isArrowDomain: isArrowDomain });

    var quickHireForm = jq('#modal-hire-me-new');

    if (quickHireForm.length) {
      quickHireForm.remove();
    }

    hireMeModal = new Modal('modal-hire-me-new', {
      body: quickHireFormHTML,
      header: quickHireFormHeaderHTML }, {
      extraClass: 'quick-hire-form-container',
      backdropClose: false,
      onHide: function onHide() {
        if (isOnMilestoneCreation) {
          qtsp.push({
            eventName: 'user_action',
            section: 'HireMe',
            subsection: 'CreateMilestoneModal',
            label: 'Close' });

          window.location.href = milestoneCreationCancelRedirectUrl;
        }
      } });

    var formContainer = jq('#quick-hire-form');
    fileUploadParams = jq.extend({
      domEl: formContainer,
      uploadTemplate: 'quickhire-template-upload',
      downloadTemplate: 'quickhire-template-download' }, fileUploadParams);

    quickhireFormContainerDom = formContainer;
    thisUser = getUserIdfromCookie();

    if (!thisUser) {
      window.webappCompatModals.open('LoginSignupModal', {
        inputs: {
          form: 'signup',
          forceAccountType: 'employer',
          skipSuccessRedirectView: true },

        size: 'xsmall',
        edgeToEdge: true,
        closeable: true,
        mobileFullscreen: true }, function (user) {
        if (user) {
          thisUser = true;
          lazyLoadPostProjectParams(hireMeLoadCallback);
        }
      });
    } else if (isDeloitteUser) {
      showHireMeWebappModal();
    } else {
      showHireMeModal(hireMeModal, hireMeParams, fileUploadParams);
    }
  };

  var initPrehireMilestoneFormCallBack = function initPrehireMilestoneFormCallBack() {
    var minBudgetForCurrency = _.find(budgetsCache, function (budget) {
      return budget.vars.currency.id == hireMeParams.employer.primary_currency.id;
    });

    var prehireMilestoneFormHTML = _.template(quickHireMilestoneFormTemplate)({
      abTestPrehire: hireMeParams.abTestPrehire,
      username: hireMeParams.freelancer.username,
      currency: hireMeParams.employer.primary_currency,
      budget: minBudgetForCurrency.vars.budgets.fixed[0].min_sum,
      abTestSkipMilestone: abTestSkipMilestone,
      T_: translate,
      cdn_url: cdn_url });

    if (typeof hireMeModal === 'undefined') {
      hireMeModal = new Modal('modal-chat-project-new', {
        body: prehireMilestoneFormHTML });
    } else {
      jq('#modal-chat-project-new').find('.Modal-body').html(prehireMilestoneFormHTML);
    }

    quickhireFormContainerDom = jq('.milestone-modal-wrapper');

    var milestoneForm = quickhireFormContainerDom.find('.quick-hire-milestone-form');

    initMilestoneValidator(quickhireFormContainerDom.find(milestoneForm));

    quickhireFormContainerDom.on('click', '.btn-quickhire-create-milestone', function () {
      if (validateMilestoneForm(milestoneForm)) {
        createPrehireProject(hireMeParams, milestoneForm);
      }
    });

    var upsellData = {
      abTestPrehire: hireMeParams.abTestPrehire,
      currency_id: hireMeParams.employer.primary_currency.id,
      currency_sign: hireMeParams.employer.primary_currency.sign,
      currency_code: hireMeParams.employer.primary_currency.code };

    upsellUpgrades(upsellData);

    hireMeModal.show();
  };

  if (hireMeParams.abTestPrehire) {
    hireMeLoadCallback = initPrehireMilestoneFormCallBack;
  } else {
    hireMeLoadCallback = initCallback;
  }

  if (!budgetsCache.length || !durationsCache.length) {
    lazyLoadPostProjectParams(hireMeLoadCallback);
  } else {
    hireMeLoadCallback();
  }

  if (hireMeParams.abTestPrehire) {
    return hireMeParams.deferred.promise;
  }
}

function showPaymentVerificationModal(paymentVerifyUrl) {
  var showPaymentVerificationModal = new Modal('modal-payment-verification', {
    body: _.template(paymentVerificationTemplate)({
      paymentVerifyUrl: paymentVerifyUrl,
      pppRedirectUrl: '/post-project' }) }, {
    extraClass: 'ModalPaymentVerification',
    backdropClose: false,
    onShow: function onShow() {
      jq('#verify-now').on('click', function () {
        qtsp.push({
          eventName: 'user_action',
          section: 'force_verify_hm_modal',
          label: 'Verify Now' });
      });

      jq('#verify-later').on('click', function () {
        qtsp.push({
          eventName: 'user_action',
          section: 'force_verify_hm_modal',
          label: 'Or Post a Project and Verify Later' });
      });
    },
    onHide: function onHide() {
      qtsp.push({
        eventName: 'user_action',
        section: 'force_verify_hm_modal',
        name: 'cancel',
        label: 'close' });

      jq('#modal-payment-verification').remove();
    } });

  showPaymentVerificationModal.show();
}

function selectBudgetType(hireMeParams, projectTypeDom) {
  if (typeof hireMeParams === 'undefined' || typeof hireMeParams.budget_period === 'undefined' || typeof projectTypeDom === 'undefined') ; else if (hireMeParams.budget_period === 'hourly') {
    projectTypeDom.val('hourly').trigger('change');
  } // defaults to fixed
}

function showFixedBudgetSuggestion(userId, userName, form) {
  var fixedBudgetSuggestion = void 0;
  var initialFixBudgetSuggetion = function initialFixBudgetSuggetion() {
    if (typeof fixedBudgetSuggestion !== 'undefined') {
      var content = translate('<%= userName %> amekubali miradi sawa kwa $<%= fixedBudgetSuggestion %> USD', {
        userName: userName,
        fixedBudgetSuggestion: fixedBudgetSuggestion });

      jq(form).find('#qh_fixed_budget').popover({
        title: translate('Hauna uhakika kuhusu Bajeti?'),
        content: content,
        trigger: 'manual',
        placement: 'bottom',
        html: true });

      // prefill the budget
      jq(form).find('#qh_fixed_budget').val(fixedBudgetSuggestion);
    }
  };
  var showFixBudgetSuggestion = function showFixBudgetSuggestion() {
    jq(form).find('#qh_fixed_budget').popover('show');
  };
  var hideFixBudgetSuggestion = function hideFixBudgetSuggestion() {
    jq(form).find('#qh_fixed_budget').popover('hide');
  };
  var toggleFixBudgetSuggestion = function toggleFixBudgetSuggestion() {
    jq(form).find('#qh_fixed_budget:visible').popover('toggle');
  };

  jq.ajax({
    url: '/ajax/hireme/getFixedProjectBudgetSuggestion.php?user_id=' + userId,
    dataType: 'json',
    success: function success(resp) {
      if (resp.status == 'success' && resp.result != null && resp.result < 500 && resp.result > 300) {
        fixedBudgetSuggestion = resp.result;
        initialFixBudgetSuggetion();
      }
    }
  });

  jq(form).find('#qh_fixed_budget').focus(showFixBudgetSuggestion);
  jq(form).find('#qh_fixed_budget').blur(hideFixBudgetSuggestion);
  jq(form).find('.fixed').parent().click(toggleFixBudgetSuggestion);
  jq(form).find('.hourly').parent().click(hideFixBudgetSuggestion);
}

function lazyLoadPostProjectParams(callback) {
  jq.ajax({
    url: '/ajax/buyer/load-post-project-params.php?freelancerId=' + freelancerUserId,
    dataType: 'json',
    success: function success(response) {
      budgetsCache = jq.map(response.budgets, function (key) {
        return [key];
      });
      durationsCache = response.durations;
      isEscrowComRequired = response.isEscrowComRequired;

      callback();
    }
  });
}

var moduleQuickHire = {
  initForm: initForm };

var selectors$1 = {
  hireMeButton: 'button[data-hook="hireMeBtn"]',
  socialShareButtons: '[data-socialshare]'
};

var hireMeBtn = document.querySelector(selectors$1.hireMeButton);
hireMeBtn.addEventListener('click', openHiremeModalForm);

function openHiremeModalForm() {
  var params = {
    userID: authorUserData.id,
    username: authorUserData.username,
    hourlyrate: authorUserData.hourly_rate,
    avatar: authorUserData.avatar_cdn,
    isNewUser: isNewUser
  };

  moduleQuickHire.initForm(params);
}

Array.from(document.querySelectorAll(selectors$1.socialShareButtons)).forEach(function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    sharePortfolioWindow(element.dataset.socialshare, element.getAttribute('href'));
  });
});

function sharePortfolioWindow(channel, url) {
  qtsp.push({
    eventName: 'user_action',
    section: 'PortfolioPage',
    label: channel,
    name: 'SocialShare',
    reference: 'portfolio_id',
    reference_id: portfolioData.id
  });

  var width = 600;
  var left = window.screen.width / 2 - width / 2;
  var top = 200;
  var shareWindow = window.open(url, 'Freelancer.com', 'width=600, height=400, left=' + left + ', top=' + top);
  shareWindow.moveTo(left, top);
}
